<template>
	<div class="Quotation quotation-sheet" :class="{ 'is-mobile': isMobile }">
		<common-body aside="3">
			<div slot="commonMain" class="quotation_box" v-loading='loading'>
				<div v-if="draftConfirmMask" class="quotation-draft-mask" aria-hidden="true"></div>
				<el-form :rules="rules" ref='quotationForm' label-position="right" :model="quotationForm" class="quotation_form">
					<el-row type="flex" align="middle" justify="space-between" class="quotation_title quotation_title--info">
						<div class="title_leading">
							<div class="title_text">客户信息</div>
							<div v-if="!hasCustomerInfo" class="title_edit" @click="openCustomerInfoDialog">添加客户</div>
						</div>
						<div class="title_actions title_actions--info">
							<div class="title_toggle" @click="toggleCustomerInfo">
								<i :class="customerInfoCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
								<span>{{customerInfoCollapsed ? '展开' : '折叠'}}</span>
							</div>
						</div>
					</el-row>
					<div v-show="!customerInfoCollapsed && hasCustomerInfo">
					<div v-if="isMobile" class="qm-info">
						<button type="button" class="qm-info-edit" @click="openCustomerInfoDialog">编辑</button>
						<div class="qm-info-grid">
							<div class="qm-info-item">
								<div class="qm-info-label">报价编号</div>
								<div class="qm-info-value qm-info-value--num">{{ displayText(quotationForm.order_number) }}</div>
							</div>
							<div class="qm-info-item">
								<div class="qm-info-label">报价日期</div>
								<div class="qm-info-value qm-info-value--num">{{ displayText(quotationForm.createTime) }}</div>
							</div>
							<div class="qm-info-item qm-info-item--full">
								<div class="qm-info-label">客户名称</div>
								<div class="qm-info-value">
									<span>{{ displayText(customerNameText) }}</span>
									<span v-if="customerDiscountRate != 1" class="qm-info-tag">折扣率 {{ customerDiscountRate }}</span>
									<span v-if="hasCustomerExclusivePrice" class="qm-info-tag">专属价 {{ customerExclusivePriceCount }}</span>
								</div>
							</div>
							<div class="qm-info-item qm-info-item--full">
								<div class="qm-info-label">收货地址</div>
								<div class="qm-info-value">{{ displayText(quotationForm.receiving_address) }}</div>
							</div>
							<div class="qm-info-item">
								<div class="qm-info-label">联系人</div>
								<div class="qm-info-value">{{ displayText(quotationForm.contacts) }}</div>
							</div>
							<div class="qm-info-item">
								<div class="qm-info-label">联系电话</div>
								<div class="qm-info-value qm-info-value--num">{{ displayText(quotationForm.contacts_phone) }}</div>
							</div>
							<div class="qm-info-item qm-info-item--full">
								<div class="qm-info-label">货物运输</div>
								<el-form-item prop="delivery" class="qm-info-field">
									<el-select
										class="qm-info-select"
										popper-class="info-view-select-dropdown"
										v-model="quotationForm.delivery"
										placeholder="请选择"
										@change="onTransportInvoiceSelectChange">
										<el-option
											v-for="item in delivery"
											:key="'m-d-' + item.id"
											:label="item.name"
											:value="item.id">
											<span class="info-view-option">
												<span class="info-view-option__name">{{ item.name }}</span>
												<span
													class="info-view-option__default"
													:class="{ 'is-active': isDefaultOption('delivery', item.id) }"
													@click.stop="pinFieldDefault('delivery', item.id)">
													{{ isDefaultOption('delivery', item.id) ? '取消默认' : '设为默认' }}
												</span>
											</span>
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="qm-info-item qm-info-item--full">
								<div class="qm-info-label">发票类型</div>
								<el-form-item prop="invoice" class="qm-info-field">
									<el-select
										class="qm-info-select"
										popper-class="info-view-select-dropdown"
										v-model="quotationForm.invoice"
										placeholder="请选择"
										@change="onTransportInvoiceSelectChange">
										<el-option
											v-for="item in invoice"
											:key="'m-i-' + item.id"
											:label="item.name"
											:value="item.id">
											<span class="info-view-option">
												<span class="info-view-option__name">{{ item.name }}</span>
												<span
													class="info-view-option__default"
													:class="{ 'is-active': isDefaultOption('invoice', item.id) }"
													@click.stop="pinFieldDefault('invoice', item.id)">
													{{ isDefaultOption('invoice', item.id) ? '取消默认' : '设为默认' }}
												</span>
											</span>
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</div>
					<div v-else class="quotation_info quotation_info--view">
						<div class="title_edit title_edit--info" @click="openCustomerInfoDialog">编辑</div>
						<el-row :gutter="24" class="quotation_info_row">
							<el-col :span="8">
								<div class="info-view-item">
									<div class="info-view-label">报价编号</div>
									<div class="info-view-value info-view-value--num">{{ displayText(quotationForm.order_number) }}</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item info-view-item--customer">
									<div class="info-view-label">客户名称</div>
									<div class="info-view-value info-view-value--customer">
										<span class="info-view-customer-name">{{ displayText(customerNameText) }}</span>
										<span v-if="customerDiscountRate != 1" class="info-view-discount">
											<span class="info-view-discount-label">折扣率</span>
											<span class="info-view-discount-value info-view-value--num">{{ customerDiscountRate }}</span>
										</span>
										<span v-if="hasCustomerExclusivePrice" class="info-view-exclusive">专属价 {{ customerExclusivePriceCount }}</span>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item">
									<div class="info-view-label">报价日期</div>
									<div class="info-view-value info-view-value--num">{{ displayText(quotationForm.createTime) }}</div>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="24" class="quotation_info_row quotation_info_row--bottom">
							<el-col :span="8">
								<div class="info-view-item info-view-item--address">
									<div class="info-view-label">收货地址</div>
									<div class="info-view-value info-view-value--multiline">{{ displayText(quotationForm.receiving_address) }}</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item">
									<div class="info-view-label">联系人</div>
									<div class="info-view-value">{{ displayText(quotationForm.contacts) }}</div>
								</div>
								<div class="info-view-item">
									<div class="info-view-label">联系电话</div>
									<div class="info-view-value info-view-value--num">{{ displayText(quotationForm.contacts_phone) }}</div>
								</div>
							</el-col>
							<el-col :span="8" class="quotation_info_selects">
								<div class="info-view-item info-view-item--select">
									<div class="info-view-label">货物运输</div>
									<el-form-item prop="delivery" class="info-view-form-item">
										<el-select
											class="info-view-select field-full"
											popper-class="info-view-select-dropdown"
											size="mini"
											v-model="quotationForm.delivery"
											placeholder="请选择"
											@change="onTransportInvoiceSelectChange">
											<el-option
												v-for="item in delivery"
												:key="item.id"
												:label="item.name"
												:value="item.id">
												<span class="info-view-option">
													<span class="info-view-option__name">{{ item.name }}</span>
													<span
														class="info-view-option__default"
														:class="{ 'is-active': isDefaultOption('delivery', item.id) }"
														@click.stop="pinFieldDefault('delivery', item.id)">
														{{ isDefaultOption('delivery', item.id) ? '取消默认' : '设为默认' }}
													</span>
												</span>
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="info-view-item info-view-item--select">
									<div class="info-view-label">发票类型</div>
									<el-form-item prop="invoice" class="info-view-form-item">
										<el-select
											class="info-view-select field-full"
											popper-class="info-view-select-dropdown"
											size="mini"
											v-model="quotationForm.invoice"
											placeholder="请选择"
											@change="onTransportInvoiceSelectChange">
											<el-option
												v-for="item in invoice"
												:key="item.id"
												:label="item.name"
												:value="item.id">
												<span class="info-view-option">
													<span class="info-view-option__name">{{ item.name }}</span>
													<span
														class="info-view-option__default"
														:class="{ 'is-active': isDefaultOption('invoice', item.id) }"
														@click.stop="pinFieldDefault('invoice', item.id)">
														{{ isDefaultOption('invoice', item.id) ? '取消默认' : '设为默认' }}
													</span>
												</span>
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</el-col>
						</el-row>
					</div>
					</div>
					<el-row type="flex" align="middle" justify="space-between" class="quotation_title quotation_title--list">
						<div class="title_text">报价清单如下：</div>
						<div class="title_actions">
							<div
								class="title_stats"
								:class="{ 'is-active': goodsStatsVisible }"
								@click="goodsStatsVisible = !goodsStatsVisible"
							>{{ goodsStatsVisible ? '隐藏统计' : '统计' }}</div>
							<div @click="showGood" class="title_add">添加产品</div>
							<div @click="addExtraFeeRow" class="title_add title_add--secondary">添加费用项</div>
						</div>
					</el-row>
					<el-table v-if="!isMobile" :row-class-name="tableRowClassName" ref='quotationTable' class="detailTable" stripe @row-dblclick="onTableRowDblClick" :border="border" :data="quotationTableRows" style="width: 100%"
					 cell-class-name="good_text" header-cell-class-name="good_header">
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="3%" label="序号" class-name="is-num">
							<template slot-scope="scope">
								<div>{{scope.$index+1}}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%" label="名称">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<div class="good_name">{{ extraFeeLines[scope.row._extraIndex].name || '未选择费用项' }}</div>
								</template>
								<el-popover v-else placement="top" trigger="hover" popper-class="quotation-good-popover">
									<div class="good_reference">
										<img :src="scope.row.sku_image_text" />
									</div>
								    <div slot="reference" class="good_name">{{ cartDisplayName(scope.row) }}</div>
								  </el-popover>
							</template>
						</el-table-column>
						<el-table-column v-if="quotationForm.category!=13&&quotationForm.category!=19&&quotationForm.category!=29&&quotationForm.category!=30&&quotationForm.category!=31&&quotationForm.category!=40&&quotationForm.category!=43&&quotationForm.category!=45" :key="Math.random()" :resizable="resizeable" align="center" min-width="10%" label="尺寸(mm)" class-name="is-size">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
									<div v-else :class="{'cart-cell-pending': isCartSizePending(scope.row)}">{{ displayCartSize(scope.row) }}</div>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="14%" label="规格参数">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
									<span v-else>{{ scope.row.parameter_text }}</span>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column v-if="quotationForm.category==20||quotationForm.category==25||quotationForm.category==26||quotationForm.category==27||quotationForm.category==28||quotationForm.category==32||quotationForm.category==33||quotationForm.category==44" :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="面积(㎡)" class-name="is-num">
							<template slot-scope="scope">
								<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
								<div v-else>{{ scope.row.goods_areas }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="数量" class-name="is-num is-qty">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<input
										v-if="editingExtraQtyIndex === scope.row._extraIndex"
										:ref="'extraQtyInput_' + scope.row._extraIndex"
										class="extra-fee-qty-input"
										type="text"
										inputmode="numeric"
										:value="extraFeeLines[scope.row._extraIndex].qty"
										@input="onExtraQtyInput(scope.row._extraIndex, $event.target.value)"
										@blur="finishExtraQtyEdit(scope.row._extraIndex)"
										@keyup.enter.native="finishExtraQtyEdit(scope.row._extraIndex)" />
									<div
										v-else
										class="extra-fee-qty-display"
										title="点击修改数量"
										@click.stop="startExtraQtyEdit(scope.row._extraIndex)">{{ extraFeeQty(extraFeeLines[scope.row._extraIndex]) }}</div>
								</template>
								<div v-else :class="{'cart-cell-pending': isCartNumPending(scope.row)}">{{ displayCartNum(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="单位">
							<template slot-scope="scope">
								<span v-if="isExtraTableRow(scope.row)" class="extra-cell-unit">{{ scope.row.goods_unit }}</span>
								<span v-else>{{ scope.row.goods_unit }}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" prop="original_price"
						 label="单价" class-name="is-amount">
						</el-table-column> -->
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="单价" class-name="is-amount">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<input
										v-if="editingExtraUnitIndex === scope.row._extraIndex"
										:ref="'extraUnitInput_' + scope.row._extraIndex"
										class="amount extra-fee-amount-input"
										type="text"
										inputmode="decimal"
										:value="extraFeeLines[scope.row._extraIndex].unit_price"
										@input="onExtraUnitInput(scope.row._extraIndex, $event.target.value)"
										@blur="finishExtraUnitEdit(scope.row._extraIndex)"
										@keyup.enter.native="finishExtraUnitEdit(scope.row._extraIndex)" />
									<div
										v-else
										class="amount extra-fee-amount-display"
										title="点击修改单价"
										@click.stop="startExtraUnitEdit(scope.row._extraIndex)">{{ formatExtraUnitDisplay(scope.row._extraIndex) }}</div>
								</template>
								<div v-else class="amount">{{ formatMoney(scope.row.singleton) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="折扣价">
							<template slot-scope="scope">
								<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
								<div
									v-else
									class="amount"
									:class="{ 'amount--discount': !isDiscountSameAsSingleton(scope.row) }"
								>{{ formatDiscountPriceCell(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="金额" class-name="is-amount">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<div class="amount">{{ formatExtraAmountDisplay(scope.row._extraIndex) }}</div>
								</template>
								<div
									v-else
									class="amount"
									:class="{ 'amount--exclusive': isExclusivePriceRow(scope.row) }"
								>{{ formatAmountCell(scope.row) }}</div>
							</template>
						</el-table-column>
						<!-- <el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="参考图">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<div class="good_icon">
										<i v-if="scope.row.reference_image&&scope.row.reference_image!=''" class="el-icon-picture-outline"></i>
									</div>
								</el-row>
							</template>
						</el-table-column> -->
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%" label="备注">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<div v-if="isExtraTableRow(scope.row)">{{ extraFeeLines[scope.row._extraIndex].remark || '' }}</div>
									<div v-else>{{ scope.row.remarks || '' }}</div>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" width="196" label="操作" class-name="quotation-action-col">
							<template slot-scope="scope">
								<div class="lq-row-actions">
									<el-tooltip v-if="isExtraTableRow(scope.row)" content="编辑" placement="top">
										<el-button type="text" icon="el-icon-edit" class="lq-row-action-btn" @click.stop="openExtraFeeDialog(scope.row._extraIndex)" />
									</el-tooltip>
									<template v-if="!isExtraTableRow(scope.row)">
									<el-tooltip content="编辑" placement="top">
										<el-button type="text" icon="el-icon-edit" class="lq-row-action-btn" @click.stop="editCart(scope.row)" />
									</el-tooltip>
									<el-tooltip content="克隆" placement="top">
										<el-button type="text" icon="el-icon-document-copy" class="lq-row-action-btn" @click.stop="cloneCart(scope.row._cartIndex)" />
									</el-tooltip>
									<el-tooltip content="上移" placement="top">
										<el-button type="text" icon="el-icon-top" class="lq-row-action-btn" @click.stop="upLayer(scope.row._cartIndex, scope.row)" />
									</el-tooltip>
									<el-tooltip content="下移" placement="top">
										<el-button type="text" icon="el-icon-bottom" class="lq-row-action-btn" @click.stop="downLayer(scope.row._cartIndex, scope.row)" />
									</el-tooltip>
									</template>
									<el-popconfirm @confirm="delTableRow(scope.row)" confirmButtonType="danger" confirmButtonText="删除" :title="isExtraTableRow(scope.row) ? '确定删除该费用项吗？' : '确定删除该产品吗？'">
										<el-tooltip content="删除" placement="top" slot="reference">
											<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" @click.stop />
										</el-tooltip>
									</el-popconfirm>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div v-else class="qm-sheet">
						<div v-if="!quotationTableRows.length" class="qm-empty">暂无产品，请先添加产品</div>
						<div v-else class="qm-sheet__scroller">
							<table class="qm-sheet__table">
								<thead>
									<tr>
										<th class="qm-sheet__col-idx">序号</th>
										<th class="qm-sheet__col-name">名称</th>
										<th v-if="showSizeColumn" class="qm-sheet__col-size">尺寸(mm)</th>
										<th class="qm-sheet__col-spec">规格参数</th>
										<th v-if="showAreaColumn" class="qm-sheet__col-area">面积(㎡)</th>
										<th class="qm-sheet__col-qty">数量</th>
										<th class="qm-sheet__col-amt">单价</th>
										<th class="qm-sheet__col-amt">折扣价</th>
										<th class="qm-sheet__col-amt">金额</th>
										<th class="qm-sheet__col-remark">备注</th>
										<th class="qm-sheet__col-ops">操作</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(row, idx) in quotationTableRows"
										:key="isExtraTableRow(row) ? 'extra-' + row._extraIndex : 'cart-' + row._cartIndex"
										:class="mobileSheetRowClass(row)">
										<td class="qm-sheet__col-idx">{{ idx + 1 }}</td>
										<td class="qm-sheet__col-name">
											<template v-if="isExtraTableRow(row)">{{ extraFeeLines[row._extraIndex].name || '未选择费用项' }}</template>
											<template v-else>{{ cartDisplayName(row) }}</template>
										</td>
										<td v-if="showSizeColumn" class="qm-sheet__col-size">
											<span v-if="isExtraTableRow(row)">-</span>
											<span v-else :class="{'cart-cell-pending': isCartSizePending(row)}">{{ displayCartSize(row) }}</span>
										</td>
										<td class="qm-sheet__col-spec">
											<span v-if="isExtraTableRow(row)">-</span>
											<span v-else>{{ row.parameter_text || '—' }}</span>
										</td>
										<td v-if="showAreaColumn" class="qm-sheet__col-area">
											<span v-if="isExtraTableRow(row)">-</span>
											<span v-else>{{ row.goods_areas || '—' }}</span>
										</td>
										<td class="qm-sheet__col-qty">
											<template v-if="isExtraTableRow(row)">
												<input
													v-if="editingExtraQtyIndex === row._extraIndex"
													:ref="'extraQtyInput_' + row._extraIndex"
													class="extra-fee-qty-input"
													type="text"
													inputmode="numeric"
													:value="extraFeeLines[row._extraIndex].qty"
													@input="onExtraQtyInput(row._extraIndex, $event.target.value)"
													@blur="finishExtraQtyEdit(row._extraIndex)"
													@keyup.enter.native="finishExtraQtyEdit(row._extraIndex)" />
												<span
													v-else
													class="extra-fee-qty-display"
													@click.stop="startExtraQtyEdit(row._extraIndex)">{{ extraFeeQty(extraFeeLines[row._extraIndex]) }}</span>
											</template>
											<span v-else :class="{'cart-cell-pending': isCartNumPending(row)}">{{ displayCartNum(row) }} {{ row.goods_unit }}</span>
										</td>
										<td class="qm-sheet__col-amt">
											<template v-if="isExtraTableRow(row)">
												<input
													v-if="editingExtraUnitIndex === row._extraIndex"
													:ref="'extraUnitInput_' + row._extraIndex"
													class="amount extra-fee-amount-input"
													type="text"
													inputmode="decimal"
													:value="extraFeeLines[row._extraIndex].unit_price"
													@input="onExtraUnitInput(row._extraIndex, $event.target.value)"
													@blur="finishExtraUnitEdit(row._extraIndex)"
													@keyup.enter.native="finishExtraUnitEdit(row._extraIndex)" />
												<span
													v-else
													class="amount extra-fee-amount-display"
													@click.stop="startExtraUnitEdit(row._extraIndex)">{{ formatExtraUnitDisplay(row._extraIndex) }}</span>
											</template>
											<span v-else class="amount">{{ formatMoney(row.singleton) }}</span>
										</td>
										<td class="qm-sheet__col-amt">
											<span v-if="isExtraTableRow(row)">-</span>
											<span v-else class="amount" :class="{ 'amount--discount': !isDiscountSameAsSingleton(row) }">{{ formatDiscountPriceCell(row) }}</span>
										</td>
										<td class="qm-sheet__col-amt">
											<span v-if="isExtraTableRow(row)" class="amount">{{ formatExtraAmountDisplay(row._extraIndex) }}</span>
											<span v-else class="amount" :class="{ 'amount--exclusive': isExclusivePriceRow(row) }">{{ formatAmountCell(row) }}</span>
										</td>
										<td class="qm-sheet__col-remark">
											<span v-if="isExtraTableRow(row)">{{ extraFeeLines[row._extraIndex].remark || '—' }}</span>
											<span v-else>{{ row.remarks || '—' }}</span>
										</td>
										<td class="qm-sheet__col-ops">
											<div class="qm-sheet__ops">
												<el-button v-if="isExtraTableRow(row)" type="text" icon="el-icon-edit" class="lq-row-action-btn" @click.stop="openExtraFeeDialog(row._extraIndex)" />
												<template v-if="!isExtraTableRow(row)">
													<el-button type="text" icon="el-icon-edit" class="lq-row-action-btn" @click.stop="editCart(row)" />
													<el-button type="text" icon="el-icon-document-copy" class="lq-row-action-btn" @click.stop="cloneCart(row._cartIndex)" />
													<el-button type="text" icon="el-icon-top" class="lq-row-action-btn" @click.stop="upLayer(row._cartIndex, row)" />
													<el-button type="text" icon="el-icon-bottom" class="lq-row-action-btn" @click.stop="downLayer(row._cartIndex, row)" />
												</template>
												<el-popconfirm @confirm="delTableRow(row)" confirmButtonType="danger" confirmButtonText="删除" :title="isExtraTableRow(row) ? '确定删除该费用项吗？' : '确定删除该产品吗？'">
													<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" slot="reference" @click.stop />
												</el-popconfirm>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="qm-dock">
					<div class="goods_footer">
						<el-row type="flex" align="middle" class="goods_footer_item goods_footer_item--amount">
							<div class="goods_footer_amount_block">
								<el-row type="flex" align="middle" class="goods_footer_amount_line">
									<div class="goods_footer_text goods_footer_text--strong">小计：<span class="amount">¥</span></div>
									<el-form-item :show-message="showMsg" prop="totalAll" class="goods_footer_money_item">
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											placeholder="请输入"
											v-model="quotationForm.totalAll"
											@blur="formatFooterAmount('totalAll')"
										></el-input>
									</el-form-item>
								</el-row>
							</div>
							<div
								class="goods_footer_amount_spacer"
								aria-hidden="true"
								:style="{ flex: '0 0 ' + footerAmountSpacerPx + 'px', width: footerAmountSpacerPx + 'px', maxWidth: footerAmountSpacerPx + 'px' }"
							></div>
						</el-row>
						<el-row type="flex" align="middle" class="goods_footer_item goods_footer_item--amount">
							<div class="goods_footer_text goods_footer_maker">制单人：{{userInfo.nickname}}</div>
							<div class="goods_footer_amount_block goods_footer_amount_block--inline">
								<el-row type="flex" align="middle" class="goods_footer_amount_line goods_footer_amount_line--pair">
									<span
										v-if="quotationForm.customer_id"
										class="goods_footer_text goods_footer_discount_rate">
										折扣率 {{ customerDiscountRateDisplay }}
									</span>
									<div class="goods_footer_text goods_footer_text--strong">折扣让利：<span class="amount">-¥</span></div>
									<el-form-item :show-message="showMsg" prop="concession" class="goods_footer_money_item">
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											placeholder="0.00"
											:value="concessionAbsText"
										></el-input>
									</el-form-item>
									<div class="goods_footer_text goods_footer_text--strong goods_footer_text--pair-gap">合计：<span class="amount">¥</span></div>
									<el-form-item prop="total" class="goods_footer_money_item">
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											placeholder="请输入"
											v-model="quotationForm.total"
											@blur="formatFooterAmount('total')"
										></el-input>
									</el-form-item>
								</el-row>
							</div>
							<div
								class="goods_footer_amount_spacer"
								aria-hidden="true"
								:style="{ flex: '0 0 ' + footerAmountSpacerPx + 'px', width: footerAmountSpacerPx + 'px', maxWidth: footerAmountSpacerPx + 'px' }"
							></div>
						</el-row>
						<el-row type="flex" align="top" class="goods_footer_item goods_footer_item--remark">
							<div class="goods_footer_text goods_footer_text--remark">订单备注：</div>
							<el-form-item prop="remarks" class="goods_footer_remark_item">
								<el-input
									type="textarea"
									:autosize="{ minRows: 2, maxRows: 5 }"
									:clearable="clearable"
									resize="none"
									class="goods_footer_remark"
									placeholder="请输入订单备注"
									v-model="quotationForm.remarks" />
							</el-form-item>
						</el-row>
					</div>
					<el-form-item>
						<div class="quotation_btn" @click="submitForm('quotationForm')">确认单据</div>
					</el-form-item>
					</div>
				</el-form>
				<!-- 客户信息编辑 -->
				<customer-info-dialog
					ref="customerInfoDialog"
					:visible.sync="customerInfoStatus"
					:is-mobile="isMobile"
					:title="customerInfoDialogTitle"
					:draft="customerInfoDraft"
					:rules="customerRules"
					:readonly="readonly"
					:clearable="clearable"
					:editable="editable"
					:customer-select-options="customerSelectOptions"
					:show-source="true"
					:customer-source-owner-id="customerSourceOwnerId"
					:customer-share-sources="customerShareSources"
					:option-label="customerOptionLabel"
					:option-value="customerOptionValue"
					:filter-method="filterCustomerOptions"
					@source-change="onCustomerSourceChange"
					@select-visible="onCustomerSelectVisible"
					@customer-change="onDraftCustomerChange"
					@close="cancelCustomerInfo"
					@cancel="cancelCustomerInfo"
					@confirm="confirmCustomerInfo" />
				<el-dialog
					class="extra_fee_dialog"
					:class="{ 'is-mobile-dialog': isMobile }"
					:visible.sync="extraFeeDialogVisible"
					:title="extraFeeEditIndex < 0 ? '添加费用项' : '编辑费用项'"
					:width="isMobile ? '96%' : '480px'"
					:append-to-body="true"
					:close-on-click-modal="true"
					:z-index="4200">
					<el-form :label-position="isMobile ? 'left' : 'top'" class="extra_fee_form" :class="{ 'is-compact': isMobile }">
						<div class="extra_fee_form_main">
							<el-form-item label="费用项" required class="extra_fee_item extra_fee_item--name">
								<el-select
									class="field-full"
									v-model="extraFeeDraft.extra_item_id"
									placeholder="请选择费用项"
									filterable
									@change="onExtraFeeDraftItemChange">
									<el-option v-for="opt in extraItemOptions" :key="opt.id" :label="opt.name" :value="opt.id" />
								</el-select>
							</el-form-item>
							<el-form-item label="单价" required class="extra_fee_item extra_fee_item--amount">
								<el-input
									v-model="extraFeeDraft.unit_price"
									placeholder="单价"
									inputmode="decimal"
									@input="onExtraFeeDraftUnitInput" />
							</el-form-item>
							<el-form-item label="数量" required class="extra_fee_item extra_fee_item--qty">
								<el-input
									v-model="extraFeeDraft.qty"
									placeholder="数量"
									inputmode="numeric"
									@input="onExtraFeeDraftQtyInput" />
							</el-form-item>
						</div>
						<el-form-item label="备注" class="extra_fee_item extra_fee_item--remark">
							<el-input
								:type="isMobile ? 'text' : 'textarea'"
								v-model="extraFeeDraft.remark"
								placeholder="选填"
								maxlength="200"
								:autosize="isMobile ? null : { minRows: 2, maxRows: 4 }"
								resize="none" />
						</el-form-item>
					</el-form>
					<div class="extra_fee_dialog_footer">
						<el-button @click="extraFeeDialogVisible = false">取消</el-button>
						<el-button type="primary" @click="confirmExtraFeeDialog">确定</el-button>
					</div>
				</el-dialog>
				<!-- 目录选择 添加产品 -->
				<good-picker-dialog
					:visible.sync="goodStatus"
					:is-mobile="isMobile"
					:search.sync="search"
					:types="types"
					:type-index.sync="typeIndex"
					:good-list="goodList"
					:resizeable="resizeable"
					@search="searchGood"
					@change-type="changeType"
					@close="closeGoodDialog"
					@choose="chooseGood"
					@row-click="onGoodRowClick"
					@current-change="selectGood" />
				<!-- 产品详情 -->
				<cart-detail-dialog
					ref="cartDetailDialog"
					:visible.sync="cartStatus"
					:is-mobile="isMobile"
					:good="good"
					:cart-form="cartForm"
					:cart-rules="cartRules"
					:sku-active="skuActive"
					:is-editing-pending-cart="isEditingPendingCart"
					:upload-limit="uploadLimit"
					:file-type="fileType"
					:modal="!goodStatus"
					:close-on-click-modal="!isMobile"
					:show-upload="!isMobile"
					@submit="submitCart"
					@select-spec="selectSpec"
					@select-mid-param="selectMidParam"
					@select-param="selectParam"
					@price-init="priceInit"
					@auto-cal-price="autoCalPrice"
					@closed="onCartDialogClosed" />
			</div>
		</common-body>
		<GoodsStatsFloat :visible.sync="goodsStatsVisible" :stats="cartGoodsStats" />
	</div>
</template>

<script>
	import GoodsStatsFloat from "@/components/GoodsStatsFloat"
	import CustomerInfoDialog from "@/components/quotation/CustomerInfoDialog.vue"
	import GoodPickerDialog from "@/components/quotation/GoodPickerDialog.vue"
	import CartDetailDialog from "@/components/quotation/CartDetailDialog.vue"
	import {
		accMul,
		accDiv,
		accAdd,
		accSub,
		getTimestamp
	} from "../assets/js/public.js"
	import {
		loadQuotationDraft,
		saveQuotationDraft,
		clearQuotationDraft,
		createQuotationDraftKey
	} from "../utils/quotation-draft.js"
	import {
		loadQuotationDefaults,
		saveQuotationDefaultField,
		optionListHasId,
		resolveOptionId,
	} from "../utils/quotation-defaults.js"
	import { applyMobileViewport } from '@/utils/isMobile'
	import { forceHideQuotationDialogs } from '@/utils/element-overlay'
	import { cartDisplayName } from '@/utils/cart-display'
	import { buildCartGoodsStats, parseCartLengthMm as parseCartLengthMmUtil } from '@/utils/cart-stats'
	import { serializeExtraFees, sumExtraFeeLines, mergeEditableTableRows, isExtraTableRow, extraFeeQty, extraFeeUnitPrice, extraFeeLineAmount, normalizeExtraFeeLine } from '@/utils/extra-fees'
	import {
		isNestedParameter as isNestedParam,
		leafOptionsForMid,
		normalizeParameterList,
		onMidParameterChange,
		onLeafParameterChange,
		flatLeafParameterChange,
		shouldShowParameterItem as isParameterItemVisible,
		collectParameterIds,
		syncSwitchParameterVisibility,
	} from '@/utils/cart-parameter'

	const QUOTATION_CATEGORY_KEY = 'quotation_category'

	export default {
		name: 'Quotation',
		components:{
			GoodsStatsFloat,
			CustomerInfoDialog,
			GoodPickerDialog,
			CartDetailDialog
		},
		data() {
			return {
				baseUrl: process.env.CDN_BASE || "http://127.0.0.1:19000/baojia-system",
				loading: !0,
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				customerInfoCollapsed: false, // 客户信息折叠状态
				customerInfoStatus: !1,
				customerInfoIsEdit: !1,
				goodsStatsVisible: !1,
				customerSelectQuery: '',
				_customerSearchSeq: 0,
				/** 0=我的客户；其它=共享来源 owner_user_id */
				customerSourceOwnerId: 0,
				customerShareSources: [],
				customerInfoDraft: {
					order_number: '',
					customer_id: '',
					receiving_address: '',
					createTime: '',
					contacts: '',
					contacts_phone: '',
				},
				quotationForm: {
					category: '',
					order_number: '',
					draft_key: '',
					customer_id: '',
					receiving_address: '',
					createTime: '',
					contacts: '',
					contacts_phone: '',
					delivery: '',
					invoice: '',
					total: 0,
					total_primary: 0,
					totalAll: 0,
					/** 让利（成交合计 − 金额小计，通常为负或 0） */
					concession: 0,
					preferential: 0,
					remarks: '',
				},
				resizeable: !1,
				editable: !1,
				clearable: !0,
				showMsg: !1,
				readonly: !0,
				border: !0,
				customerRules: {
					order_number: [{
						required: true,
						message: '报价编号不能为空',
						trigger: 'blur'
					}],
					customer_id: [{
						required: true,
						message: '请选择客户名称',
						trigger: 'change'
					}],
					receiving_address: [{
						required: true,
						message: '收货地址不能为空',
						trigger: 'blur'
					}],
					createTime: [{
						required: true,
						message: '请选择报价日期',
						trigger: 'blur'
					}],
					contacts: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contacts_phone: [{
						required: true,
						message: '联系电话不能为空',
						trigger: 'blur'
					}],
				},
				rules: {
					delivery: [{
						required: true,
						message: '请选择运输方式',
						trigger: 'change'
					}],
					invoice: [{
						required: true,
						message: '请选择发票类型',
						trigger: 'change'
					}],
				},
				page: 1,
				limit: 999,
				customer: [],
				customerIndex: '',
				/** 当前报价客户折扣率系数（1=无折扣）；专属价优先 */
				customerDiscountRate: 1,
				/** 专属价 map：`${goods_id}_${sku_id}` -> price */
				customerExclusivePriceMap: {},
				/** 专属价 map：`${goods_id}__${goods_sku_ids}` -> price（与购物车 sku_ids 对齐） */
				customerExclusiveSkuKeyMap: {},
				delivery: [],
				invoice: [],
				quotationDefaults: loadQuotationDefaults(),
				goodStatus: !1,
				resumeGoodPicker: !1,
				good: null,
				goodList: [],
				cartStatus: !1,
				cartList: [],
				extraFeeLines: [],
				extraItemOptions: [],
				editingExtraAmountIndex: -1,
				editingExtraQtyIndex: -1,
				editingExtraUnitIndex: -1,
				extraFeeDialogVisible: false,
				extraFeeEditIndex: -1,
				extraFeeDraft: {
					extra_item_id: '',
					name: '',
					qty: 1,
					unit_price: '',
					remark: '',
				},
				cartForm: {
					cart_id: "",
					goods_id: "",
					sku_ids: "",
					goods_long: "",
					goods_wide: "",
					goods_high: "",
					goods_thick: "",
					reference_image: "",
					remarks: "",
					goods_num: 1,
					goods_category: "",
					order_number: "",
					goods_size: "",
					parameter_ids: ""
				},
				cartRules: {
					
				},
				fileType: ["jpg","jpeg","png","dxf","dws","dwg"],
				specIds: [],
				search: '',
				types: [],
				typeIndex: 0,
				quotationStatus: !1,
				uploadLimit: 6,
				goodActive: 0,
				skuActive: -1,
				cartSubmit: !1,
				restoringDraft: !1,
				/** 暂存确认时仅遮罩报价主区域，不挡侧栏导航 */
				draftConfirmMask: !1,
				/** 确认单据成功后不再写回 localStorage 草稿 */
				skipDraftPersist: !1,
				persistDraftTimer: null,
				footerAmountSpacerPx: 0,
				/** 清单变更后递增，驱动 goods_stats 实时重算 */
				cartStatsTick: 0,
				isMobile: false,
			}
		},
		created() {
			this.updateIsMobile()
			this.reload();
		},
		mounted() {
			this.updateIsMobile()
			this.$nextTick(() => {
				this.syncQuotationAlign()
			})
			window.addEventListener('resize', this.onQuotationResize)
			window.addEventListener('orientationchange', this.onQuotationResize)
			if (window.visualViewport) {
				window.visualViewport.addEventListener('resize', this.onQuotationResize)
			}
		},
		watch: {
			quotationForm: {
				handler() {
					this.persistDraft()
				},
				deep: true
			},
			'quotationForm.category'() {
				this.$nextTick(() => {
					this.syncQuotationAlign()
				})
			},
			cartList: {
				handler() {
					this.persistDraft()
					this.$nextTick(() => {
						this.syncQuotationAlign()
					})
				},
				deep: true
			},
			customerIndex() {
				this.persistDraft()
			},
			customerInfoCollapsed() {
				this.persistDraft()
			},
			extraFeeLines: {
				handler() {
					this.persistDraft()
					this.getTotal()
				},
				deep: true
			},
			cartStatus() {
				this.syncCartOverlayClass()
			},
			isMobile() {
				this.syncCartOverlayClass()
			}
		},
		beforeRouteLeave(to, from, next) {
			this.closeDraftConfirmBox()
			next()
		},
		deactivated() {
			this.closeDraftConfirmBox()
		},
		beforeDestroy() {
			this.closeDraftConfirmBox()
			this.clearCartOverlayClass()
			window.removeEventListener('resize', this.onQuotationResize)
			window.removeEventListener('orientationchange', this.onQuotationResize)
			if (window.visualViewport) {
				window.visualViewport.removeEventListener('resize', this.onQuotationResize)
			}
			if (this.persistDraftTimer) clearTimeout(this.persistDraftTimer)
			if (!this.skipDraftPersist) this.persistDraft(true)
		},
		computed: {
			customerNameText() {
				const found = this.customer.find(item => String(item.id) === String(this.quotationForm.customer_id))
				if (!found) return ''
				if (found.shared && found.owner_nickname) {
					return found.name + '（' + found.owner_nickname + '）'
				}
				if (found.share_active === false && found.owner_nickname) {
					return found.name + '（所属：' + found.owner_nickname + '）'
				}
				return found.name || ''
			},
			hasCustomerInfo() {
				return !!this.quotationForm.customer_id
			},
			customerInfoDialogTitle() {
				return this.customerInfoIsEdit ? '编辑客户' : '添加客户'
			},
			customerSelectOptions() {
				const sourceId = Number(this.customerSourceOwnerId || 0)
				const list = (Array.isArray(this.customer) ? this.customer : []).filter((item) => {
					const ownerId = Number(item.owner_user_id != null ? item.owner_user_id : item.user_id || 0)
					if (!sourceId) {
						// 我的：归属当前用户，或未带 owner 字段的旧缓存
						const uid = this.userInfo && this.userInfo.id
						if (uid && ownerId) return Number(ownerId) === Number(uid)
						return !item.shared
					}
					return Number(ownerId) === sourceId
				})
				const q = (this.customerSelectQuery || '').trim().toLowerCase()
				let options = list
				if (q) {
					options = list.filter((item) => {
						const name = String(item.name || '').toLowerCase()
						const contacts = String(item.contacts || '').toLowerCase()
						const phone = String(item.phone || '').toLowerCase()
						return name.indexOf(q) !== -1 || contacts.indexOf(q) !== -1 || phone.indexOf(q) !== -1
					})
				}
				const selectedId = this.customerInfoDraft.customer_id
				if (selectedId !== '' && selectedId !== null && selectedId !== undefined) {
					const exists = options.some((item) => String(item.id) === String(selectedId))
					if (!exists) {
						const selected = (this.customer || []).find((item) => String(item.id) === String(selectedId))
						if (selected) options = [selected].concat(options)
					}
				}
				if (!q && options.length > 80) {
					const selected = selectedId !== '' && selectedId != null
						? options.find((item) => String(item.id) === String(selectedId))
						: null
					const head = options.slice(0, 80)
					if (selected && !head.some((item) => String(item.id) === String(selectedId))) {
						return [selected].concat(head)
					}
					return head
				}
				return options
			},
			isEditingPendingCart() {
				const row = this.cartList[this.goodActive]
				return !!(row && row.pending_edit)
			},
			/** 让利展示绝对值（标签已带 -￥） */
			concessionAbsText() {
				const n = Math.abs(Number(this.quotationForm.concession) || 0)
				return n.toFixed(2)
			},
			/** 底部「折扣让利」左侧展示的客户折扣率 */
			customerDiscountRateDisplay() {
				const n = Number(this.customerDiscountRate)
				if (!Number.isFinite(n) || n <= 0) return '1'
				return String(n)
			},
			/** 当前客户已设定专属价的商品数（按 goods_id 去重） */
			customerExclusivePriceCount() {
				const map = this.customerExclusivePriceMap || {}
				const goodsIds = {}
				Object.keys(map).forEach(function(key) {
					const goodsId = String(key).split('_')[0]
					if (goodsId) goodsIds[goodsId] = !0
				})
				return Object.keys(goodsIds).length
			},
			/** 当前客户是否配置了专属价格 */
			hasCustomerExclusivePrice() {
				return this.customerExclusivePriceCount > 0
			},
			/** 清单统计：总览 + 按名称/规格分组明细（与 offerEdit 共用 util） */
			cartGoodsStats() {
				const that = this
				void that.cartStatsTick
				return buildCartGoodsStats(that.cartList, {
					isNumPending(row) { return that.isCartNumPending(row) },
					isSizePending(row) { return that.isCartSizePending(row) }
				})
			},
			quotationTableRows() {
				return mergeEditableTableRows(this.cartList, this.extraFeeLines)
			},
			showSizeColumn() {
				const c = Number(this.quotationForm.category)
				return ![13, 19, 29, 30, 31, 40, 43, 45].includes(c)
			},
			showAreaColumn() {
				const c = Number(this.quotationForm.category)
				return [20, 25, 26, 27, 28, 32, 33, 44].includes(c)
			},
		},
		beforeUpdate() {
			this.$nextTick(() => {
				if (this.$refs.quotationTable) {
					this.$refs.quotationTable.doLayout()
				}
				this.syncQuotationAlign()
			})
		},
		methods: {
			cartDisplayName,
			isExtraTableRow,
			extraFeeQty,
			updateIsMobile() {
				this.isMobile = applyMobileViewport()
				this.syncCartOverlayClass()
			},
			syncCartOverlayClass() {
				if (typeof document === 'undefined') return
				const on = !!(this.isMobile && this.cartStatus)
				document.documentElement.classList.toggle('qm-cart-open', on)
			},
			clearCartOverlayClass() {
				if (typeof document === 'undefined') return
				document.documentElement.classList.remove('qm-cart-open')
			},
			onQuotationResize() {
				this.updateIsMobile()
				this.syncQuotationAlign()
			},
			closeGoodDialog() {
				this.goodStatus = false
				this.$nextTick(() => {
					if (!this.cartStatus) forceHideQuotationDialogs()
				})
			},
			openCartFromPicker() {
				// 移动端不关选品：关了再开会弄乱 Element 遮罩栈，关闭详情后残留遮罩挡操作
				const mobile = this.isMobile || (typeof document !== 'undefined' && document.documentElement.classList.contains('is-mobile-viewport'))
				if (mobile) {
					this.resumeGoodPicker = !1
					this.cartStatus = !0
					return
				}
				this.resumeGoodPicker = !!this.goodStatus
				this.goodStatus = !1
				this.$nextTick(() => {
					this.cartStatus = !0
				})
			},
			onCartDialogClosed() {
				this.clearCartOverlayClass()
				if (this.resumeGoodPicker) {
					this.resumeGoodPicker = !1
					this.goodStatus = !0
					return
				}
				this.$nextTick(() => {
					if (!this.goodStatus) forceHideQuotationDialogs()
				})
			},
			onTableRowDblClick(row) {
				if (isExtraTableRow(row)) {
					this.openExtraFeeDialog(row._extraIndex)
					return
				}
				this.editCart(row)
			},
			addExtraFeeRow() {
				this.openExtraFeeDialog(-1)
			},
			openExtraFeeDialog(index) {
				this.extraFeeEditIndex = index
				if (index >= 0 && this.extraFeeLines[index]) {
					const row = this.extraFeeLines[index]
					const unit = extraFeeUnitPrice(row)
					this.extraFeeDraft = {
						extra_item_id: row.extra_item_id,
						name: row.name || '',
						qty: extraFeeQty(row),
						unit_price: unit > 0 ? String(unit) : '',
						remark: row.remark || '',
					}
				} else {
					this.extraFeeDraft = {
						extra_item_id: '',
						name: '',
						qty: 1,
						unit_price: '',
						remark: '',
					}
				}
				this.extraFeeDialogVisible = true
			},
			onExtraFeeDraftItemChange() {
				const that = this
				const opt = (this.extraItemOptions || []).find(function(item) {
					return String(item.id) === String(that.extraFeeDraft.extra_item_id)
				})
				this.extraFeeDraft.name = opt ? opt.name : ''
			},
			onExtraFeeDraftUnitInput(val) {
				let text = String(val == null ? '' : val).replace(/[^\d.]/g, '')
				const parts = text.split('.')
				if (parts.length > 2) text = parts[0] + '.' + parts.slice(1).join('')
				this.extraFeeDraft.unit_price = text
			},
			onExtraFeeDraftQtyInput(val) {
				let text = String(val == null ? '' : val).replace(/[^\d]/g, '')
				if (text !== '') {
					const n = parseInt(text, 10)
					text = Number.isFinite(n) && n > 0 ? String(n) : ''
				}
				this.extraFeeDraft.qty = text === '' ? '' : Number(text)
			},
			confirmExtraFeeDialog() {
				if (!this.extraFeeDraft.extra_item_id) {
					this.$message({ message: '请选择费用项', type: 'warning', duration: 1500, center: true })
					return
				}
				const unit = Number(this.extraFeeDraft.unit_price)
				if (!Number.isFinite(unit) || unit <= 0) {
					this.$message({ message: '请输入有效单价', type: 'warning', duration: 1500, center: true })
					return
				}
				const qty = Number(this.extraFeeDraft.qty)
				if (!Number.isFinite(qty) || qty <= 0) {
					this.$message({ message: '请输入有效数量', type: 'warning', duration: 1500, center: true })
					return
				}
				const row = normalizeExtraFeeLine({
					extra_item_id: this.extraFeeDraft.extra_item_id,
					name: this.extraFeeDraft.name || '',
					qty,
					unit_price: unit,
					remark: this.extraFeeDraft.remark || '',
				})
				if (this.extraFeeEditIndex >= 0) {
					this.$set(this.extraFeeLines, this.extraFeeEditIndex, row)
				} else {
					this.extraFeeLines.push(row)
				}
				this.touchExtraFeeLines()
				this.getTotal()
				this.extraFeeDialogVisible = false
			},
			touchExtraFeeLines() {
				this.extraFeeLines = this.extraFeeLines.slice()
			},
			onExtraItemChange(index) {
				const row = this.extraFeeLines[index]
				if (!row) return
				const opt = (this.extraItemOptions || []).find(function(item) {
					return String(item.id) === String(row.extra_item_id)
				})
				if (opt) row.name = opt.name
				this.touchExtraFeeLines()
			},
			formatExtraAmountDisplay(index) {
				const row = this.extraFeeLines[index]
				const amount = extraFeeLineAmount(row)
				if (!(amount > 0)) return '¥ 0.00'
				return this.formatMoney(amount) || '¥ 0.00'
			},
			formatExtraUnitDisplay(index) {
				const row = this.extraFeeLines[index]
				const unit = extraFeeUnitPrice(row)
				if (!(unit > 0)) return '¥ 0.00'
				return this.formatMoney(unit) || '¥ 0.00'
			},
			focusExtraInput(refKey) {
				this.$nextTick(() => {
					const ref = this.$refs[refKey]
					const el = Array.isArray(ref) ? ref[0] : ref
					if (el && el.focus) {
						el.focus()
						el.select && el.select()
					}
				})
			},
			syncExtraFeeLine(index) {
				const row = this.extraFeeLines[index]
				if (!row) return
				const next = normalizeExtraFeeLine(row)
				if (next) this.$set(this.extraFeeLines, index, next)
				this.touchExtraFeeLines()
				this.getTotal()
			},
			startExtraQtyEdit(index) {
				this.editingExtraUnitIndex = -1
				this.editingExtraQtyIndex = index
				this.focusExtraInput('extraQtyInput_' + index)
			},
			onExtraQtyInput(index, val) {
				const row = this.extraFeeLines[index]
				if (!row) return
				let text = String(val == null ? '' : val).replace(/[^\d]/g, '')
				row.qty = text === '' ? '' : parseInt(text, 10)
				this.touchExtraFeeLines()
			},
			finishExtraQtyEdit(index) {
				const row = this.extraFeeLines[index]
				if (row) {
					const n = Number(row.qty)
					row.qty = Number.isFinite(n) && n > 0 ? n : 1
				}
				this.editingExtraQtyIndex = -1
				this.syncExtraFeeLine(index)
			},
			startExtraUnitEdit(index) {
				this.editingExtraQtyIndex = -1
				this.editingExtraUnitIndex = index
				this.focusExtraInput('extraUnitInput_' + index)
			},
			onExtraUnitInput(index, val) {
				const row = this.extraFeeLines[index]
				if (!row) return
				let text = String(val == null ? '' : val).replace(/[^\d.]/g, '')
				const parts = text.split('.')
				if (parts.length > 2) text = parts[0] + '.' + parts.slice(1).join('')
				row.unit_price = text
				this.touchExtraFeeLines()
			},
			finishExtraUnitEdit(index) {
				const row = this.extraFeeLines[index]
				if (row) {
					const n = Number(row.unit_price)
					row.unit_price = Number.isFinite(n) && n > 0 ? n.toFixed(2) : ''
				}
				this.editingExtraUnitIndex = -1
				this.syncExtraFeeLine(index)
			},
			startExtraAmountEdit(index) {
				this.startExtraUnitEdit(index)
			},
			finishExtraAmountEdit(index) {
				this.finishExtraUnitEdit(index)
			},
			onExtraAmountInput(index, val) {
				this.onExtraUnitInput(index, val)
			},
			formatExtraAmount(index) {
				this.syncExtraFeeLine(index)
			},
			delTableRow(row) {
				if (isExtraTableRow(row)) {
					this.extraFeeLines.splice(row._extraIndex, 1)
					this.getTotal()
					return
				}
				this.delGood(row._cartIndex)
			},
			// 同步 footer 金额列对齐
			syncQuotationAlign() {
				this.syncFooterAmountAlign()
			},
			// 按表格「金额」列右缘实测 footer 占位，使小计/合计输入右对齐金额列
			syncFooterAmountAlign() {
				if (this.isMobile) return
				const table = this.$refs.quotationTable
				if (!table || !table.$el) return
				const tableEl = table.$el
				const headerWrapper = tableEl.querySelector('.el-table__header-wrapper') || tableEl
				const amountThs = headerWrapper.querySelectorAll('th.is-amount')
				if (!amountThs.length) return
				const amountTh = amountThs[amountThs.length - 1]
				const tableRect = headerWrapper.getBoundingClientRect()
				const amountThRect = amountTh.getBoundingClientRect()
				const spacer = Math.max(0, Math.round(tableRect.right - amountThRect.right))
				if (spacer !== this.footerAmountSpacerPx) {
					this.footerAmountSpacerPx = spacer
				}
			},
			// 切换客户信息折叠状态
			toggleCustomerInfo() {
				this.customerInfoCollapsed = !this.customerInfoCollapsed;
			},
			displayText(val) {
				return val !== undefined && val !== null && val !== '' ? val : '—'
			},
			formatMoney(val) {
				if (val === undefined || val === null || val === '') return ''
				let text = String(val).trim()
				if (!text) return ''
				if (text.indexOf('¥') === 0 || text.indexOf('￥') === 0) text = text.slice(1).trim()
				const num = Number(text)
				if (!Number.isFinite(num)) return '¥ ' + text
				return '¥ ' + num.toFixed(2)
			},
			formatSizeText(text) {
				if (text === undefined || text === null || text === '' || text === '-') return text
				return String(text).replace(/长/g, '')
			},
			isEmptyDimValue(val) {
				if (val === undefined || val === null) return true
				const text = String(val).trim()
				return text === '' || text === '0'
			},
			isCartPendingEdit(row) {
				return !!(row && row.pending_edit)
			},
			isCartSizeInvalid(row) {
				if (!row) return false
				const v = Number(row.goods_valuation)
				if (v === 1) return false
				if (v === 2 || v === 3 || v === 8 || v === 10 || v === 11) {
					return this.isEmptyDimValue(row.goods_long)
				}
				if (v === 4 || v === 5 || v === 12 || v === 13) {
					return this.isEmptyDimValue(row.goods_long) || this.isEmptyDimValue(row.goods_wide)
				}
				if (v === 6 || v === 7) {
					return this.isEmptyDimValue(row.goods_high) || this.isEmptyDimValue(row.goods_wide)
				}
				if (v === 9) {
					return this.isEmptyDimValue(row.goods_high) || this.isEmptyDimValue(row.goods_wide) || this.isEmptyDimValue(row.goods_thick)
				}
				return false
			},
			isCartNumInvalid(row) {
				if (!row) return false
				const num = Number(row.goods_num)
				return !Number.isFinite(num) || num <= 0
			},
			isCartSizePending(row) {
				return this.isCartPendingEdit(row) && this.isCartSizeInvalid(row)
			},
			isCartNumPending(row) {
				return this.isCartPendingEdit(row) && this.isCartNumInvalid(row)
			},
			displayCartSize(row) {
				if (Number(row.goods_valuation) === 1) return '-'
				if (this.isCartSizePending(row)) return '-'
				const text = this.formatSizeText(row.size_text)
				return text || '-'
			},
			displayCartNum(row) {
				if (this.isCartNumPending(row)) return '-'
				return row.goods_num
			},
			parseCartLengthMm(row) {
				const that = this
				return parseCartLengthMmUtil(row, {
					isSizePending(r) { return that.isCartSizePending(r) }
				})
			},
			normalizePendingCartForm() {
				const fields = ['goods_long', 'goods_wide', 'goods_high', 'goods_thick']
				fields.forEach((key) => {
					if (this.isEmptyDimValue(this.cartForm[key])) this.cartForm[key] = ''
				})
				if (this.isCartNumInvalid(this.cartForm)) this.cartForm.goods_num = undefined
			},
			isCartFormPendingInvalid() {
				const formRow = Object.assign({}, this.cartForm, { goods_valuation: this.good && this.good.valuation })
				return this.isCartSizeInvalid(formRow) || this.isCartNumInvalid(formRow)
			},
			hasPendingCloneItems() {
				return this.cartList.some((row) => this.isCartNumPending(row) || this.isCartSizePending(row))
			},
			snapshotCustomerInfoDraft() {
				const form = this.quotationForm
				let customerId = form.customer_id
				if (customerId !== '' && customerId != null) {
					const found = this.customer.find((item) => String(item.id) === String(customerId))
					if (found) customerId = found.id
				}
				return {
					order_number: form.order_number,
					customer_id: this.normalizeCustomerId(customerId),
					receiving_address: form.receiving_address,
					createTime: form.createTime,
					contacts: form.contacts,
					contacts_phone: form.contacts_phone,
				}
			},
			normalizeCustomerId(id) {
				if (id === '' || id === null || id === undefined) return ''
				const n = Number(id)
				return Number.isFinite(n) ? n : id
			},
			customerOptionLabel(item) {
				if (!item) return ''
				if (item.shared && item.owner_nickname) return item.name + '（' + item.owner_nickname + '）'
				if (item.share_active === false && item.owner_nickname) {
					return item.name + '（所属：' + item.owner_nickname + '）'
				}
				return item.name || ''
			},
			customerOptionValue(item) {
				return this.normalizeCustomerId(item && item.id)
			},
			customerInfoFormRef() {
				const dlg = this.$refs.customerInfoDialog
				return (dlg && typeof dlg.getForm === 'function' && dlg.getForm()) || (dlg && dlg.$refs.customerInfoForm)
			},
			customerSelectRef() {
				const dlg = this.$refs.customerInfoDialog
				return (dlg && typeof dlg.getSelect === 'function' && dlg.getSelect()) || (dlg && dlg.$refs.customerSelect)
			},
			cartFormRef() {
				const dlg = this.$refs.cartDetailDialog
				return (dlg && typeof dlg.getForm === 'function' && dlg.getForm()) || (dlg && dlg.$refs.cartForm) || this.$refs.cartForm
			},
			loadCustomerShareSources() {
				const that = this
				return that.$fetch('addons/hlm/api.Customer/shareListIncoming').then(function(res) {
					if (res.code == 1) {
						that.customerShareSources = Array.isArray(res.data) ? res.data : []
					}
				}).catch(function() {
					that.customerShareSources = []
				})
			},
			fetchCustomersForSource(search) {
				const that = this
				const params = {
					page: 1,
					limit: that.limit || 999,
					search: search == null ? '' : String(search),
				}
				const ownerId = Number(that.customerSourceOwnerId || 0)
				if (ownerId) params.owner_user_id = ownerId
				return that.$fetch('addons/hlm/api.Customer/getCustomerList', params).then(function(res) {
					if (res.code == 1) {
						that.mergeCustomersIntoCache(res.data.list || [])
					}
				})
			},
			onCustomerSourceChange() {
				this.customerInfoDraft.customer_id = ''
				this.customerSelectQuery = ''
				this.fetchCustomersForSource('')
			},
			openCustomerInfoDialog() {
				let that = this
				that.customerInfoIsEdit = !!that.quotationForm.customer_id
				that.customerSelectQuery = ''
				that.customerInfoDraft = that.snapshotCustomerInfoDraft()
				that.customerInfoDraft.customer_id = that.normalizeCustomerId(that.customerInfoDraft.customer_id)
				const applyOpen = function() {
					that.customerInfoStatus = !0
					that.$nextTick(function() {
						const customerForm = that.customerInfoFormRef()
						if (customerForm) customerForm.clearValidate()
					})
				}
				that.loadCustomerShareSources().finally(function() {
					that.ensureSelectedCustomerLoaded().then(function() {
						const selected = (that.customer || []).find(function(item) {
							return String(item.id) === String(that.customerInfoDraft.customer_id)
						})
						if (selected) {
							const ownerId = Number(selected.owner_user_id != null ? selected.owner_user_id : selected.user_id || 0)
							const uid = that.userInfo && that.userInfo.id
							that.customerSourceOwnerId = (uid && ownerId && Number(ownerId) !== Number(uid)) ? ownerId : 0
						} else {
							that.customerSourceOwnerId = 0
						}
						return that.fetchCustomersForSource('')
					}).finally(applyOpen)
				})
			},
			ensureSelectedCustomerLoaded() {
				const that = this
				const id = that.customerInfoDraft.customer_id
				if (id === '' || id === null || id === undefined) return Promise.resolve()
				const found = (that.customer || []).find(function(item) {
					return String(item.id) === String(id)
				})
				if (found && (found.owner_user_id != null || found.user_id != null)) return Promise.resolve()
				return that.$fetch('addons/hlm/api.Customer/getCustomerDetails', { id: id }).then(function(res) {
					if (res && res.code == 1 && res.data) {
						that.mergeCustomersIntoCache([res.data])
					}
				}).catch(function() {})
			},
			mergeCustomersIntoCache(list) {
				if (!Array.isArray(list) || !list.length) return
				const map = new Map((this.customer || []).map((row) => [String(row.id), row]))
				list.forEach((row) => {
					if (row && row.id != null) map.set(String(row.id), row)
				})
				this.customer = Array.from(map.values())
				this.syncCustomerIndex()
			},
			/** 输入关键字时后台补全远端结果，本地列表先即时过滤，不挡住下拉 */
			searchCustomersRemote(query) {
				const that = this
				const q = query == null ? '' : String(query).trim()
				if (!q) return
				if (that._customerSearchTimer) {
					clearTimeout(that._customerSearchTimer)
					that._customerSearchTimer = null
				}
				const seq = ++that._customerSearchSeq
				that._customerSearchTimer = setTimeout(function() {
					that._customerSearchTimer = null
					that.fetchCustomersForSource(q).then(function() {
						if (seq !== that._customerSearchSeq) return
					}).catch(function() {})
				}, 220)
			},
			selectedCustomerLabel() {
				const id = this.customerInfoDraft && this.customerInfoDraft.customer_id
				if (id === '' || id === null || id === undefined) return ''
				const found = (this.customer || []).find((item) => String(item.id) === String(id))
				return found ? String(found.name || '') : ''
			},
			filterCustomerOptions(query) {
				const q = query == null ? '' : String(query)
				// Element 展开时会把 query 设为当前选中项名称；视为未输入，展示完整列表
				const selectedLabel = this.selectedCustomerLabel()
				if (selectedLabel && q === selectedLabel) {
					this.customerSelectQuery = ''
					return
				}
				this.customerSelectQuery = q
				this.searchCustomersRemote(q)
			},
			onCustomerSelectVisible(visible) {
				if (visible) {
					this.customerSelectQuery = ''
					// 清空内部 query，并同步 previousQuery，避免首次击键被 Element 跳过/误吞
					this.$nextTick(() => {
						const sel = this.customerSelectRef()
						if (!sel) return
						sel.query = ''
						sel.previousQuery = ''
						this.customerSelectQuery = ''
					})
					return
				}
				this.customerSelectQuery = ''
			},
			onDraftCustomerChange(id) {
				if (id === '' || id === null || id === undefined) {
					this.customerInfoDraft.customer_id = ''
					return
				}
				const normalized = this.normalizeCustomerId(id)
				const item = (this.customer || []).find((row) => String(row.id) === String(normalized))
				if (!item) return
				this.customerInfoDraft.customer_id = this.normalizeCustomerId(item.id)
				this.customerInfoDraft.contacts = item.contacts
				this.customerInfoDraft.contacts_phone = item.phone
				this.customerInfoDraft.receiving_address = item.receiving_address
			},
			cancelCustomerInfo() {
				this.customerInfoStatus = !1
				this.customerSelectQuery = ''
			},
			confirmCustomerInfo() {
				let that = this
				const customerForm = that.customerInfoFormRef()
				if (!customerForm) return
				customerForm.validate(function(valid) {
					if (!valid) return
					Object.assign(that.quotationForm, {
						order_number: that.customerInfoDraft.order_number,
						customer_id: that.customerInfoDraft.customer_id,
						receiving_address: that.customerInfoDraft.receiving_address,
						createTime: that.customerInfoDraft.createTime,
						contacts: that.customerInfoDraft.contacts,
						contacts_phone: that.customerInfoDraft.contacts_phone,
					})
					that.syncCustomerIndex()
					that.loadCustomerPricing(that.quotationForm.customer_id)
					that.customerInfoStatus = !1
					that.customerSelectQuery = ''
					that.applyQuotationDefaults()
					// 方案 A：有清单时按当前客户整表重算（仅本草稿 transient）
					if (that.cartList && that.cartList.length > 0) {
						that.repriceTransientCart()
					} else {
						that.persistDraft(!0)
					}
				})
			},
			/** 按客户折扣/专属价重算当前报价草稿清单 */
			repriceTransientCart() {
				let that = this
				const draftKey = that.quotationForm.draft_key || that.quotationForm.order_number
				if (!draftKey) return
				const ids = (that.cartList || []).map(function(row) {
					return row && row.id
				}).filter(Boolean)
				const params = {
					order_number: draftKey,
					customer_id: that.quotationForm.customer_id || 0,
					category: that.quotationForm.category
				}
				if (ids.length) params.ids = ids.join(',')
				that.$post('addons/hlm/api.Cart/repriceTransient', params).then(function(res) {
					if (res.code == 1) {
						that.cartList = Array.isArray(res.data) ? res.data : []
						that.getTotal()
						that.persistDraft(!0)
						that.$message({
							message: '已按客户折扣更新清单价格',
							type: 'success',
							duration: 2000,
							center: !0
						})
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			validateCustomerInfo(callback) {
				const form = this.quotationForm
				const valid = !!(form.order_number && form.customer_id && form.receiving_address &&
					form.createTime && form.contacts && form.contacts_phone)
				callback(valid)
			},
			/** 关闭暂存确认框（切换导航时无需先点弹窗按钮） */
			closeDraftConfirmBox() {
				this.draftConfirmMask = !1
				try {
					if (this.$msgbox && typeof this.$msgbox.close === 'function') {
						this.$msgbox.close()
					}
				} catch (e) {
					/* ignore */
				}
			},
			reload() {
				let that = this
				if (!that.initCategory()) return
				const categoryId = that.quotationForm.category
				const draft = loadQuotationDraft(categoryId)
				that.getCustomer()
				that.getType()
				if (that.delivery.length === 0) that.getDelivery(), that.getInvoice()
				that.loadExtraItemOptions()
				if (draft && draft.quotationForm) {
					that.restoreDraft(draft, categoryId, function() {
						that.draftConfirmMask = !0
						that.$confirm('本页有暂存的填写内容与产品清单，是否清除？', '提示', {
							confirmButtonText: '清除',
							cancelButtonText: '保留',
							type: 'warning',
							customClass: 'quotation-draft-confirm',
							showClose: false,
							/** 全局遮罩关闭；主区域用本地 quotation-draft-mask，侧栏可点 */
							modal: false,
							lockScroll: false,
							closeOnClickModal: false,
							closeOnPressEscape: false,
							confirmButtonType: 'danger',
							confirmButtonClass: 'quotation-draft-confirm__btn-clear',
							cancelButtonClass: 'quotation-draft-confirm__btn-keep'
						}).then(function() {
							that.draftConfirmMask = !1
							that.clearDraftAndRestart(draft)
						}).catch(function() {
							that.draftConfirmMask = !1
							// 保留 / 离开页面关闭：内容已在页面上，无需处理
						})
					})
					return
				}
				that.startFreshQuotation()
			},
			startFreshQuotation() {
				let that = this
				let myDate = new Date();
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
				let day = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				that.quotationForm.createTime = year + '-' + month + '-' + day
				that.applyQuotationDefaults()
				that.getNumber()
			},
			restoreDraft(draft, categoryId, onDone) {
				let that = this
				that.restoringDraft = !0
				Object.assign(that.quotationForm, draft.quotationForm)
				that.quotationForm.category = categoryId
				if (!that.quotationForm.draft_key && that.quotationForm.order_number) {
					const uid = that.userInfo && that.userInfo.id ? that.userInfo.id : '0'
					that.quotationForm.draft_key = createQuotationDraftKey(that.quotationForm.order_number, uid)
				}
				that.customerIndex = draft.customerIndex !== undefined && draft.customerIndex !== null ? draft.customerIndex : ''
				that.customerInfoCollapsed = !!draft.customerInfoCollapsed
				that.extraFeeLines = Array.isArray(draft.extraFeeLines)
					? draft.extraFeeLines.map(function(row) { return normalizeExtraFeeLine(row) || row }).filter(Boolean)
					: []
				const draftPending = {}
				const draftCartIds = []
				if (Array.isArray(draft.cartList)) {
					draft.cartList.forEach(function(row) {
						if (!row || !row.id) return
						draftCartIds.push(row.id)
						if (row.pending_edit) draftPending[row.id] = !0
					})
				}
				const finishDraftRestore = function() {
					that.cartList = that.cartList.map(function(row) {
						if (draftPending[row.id]) row.pending_edit = !0
						return row
					})
					that.loadCustomerPricing(that.quotationForm.customer_id)
					that.getTotal()
					that.loading = !1
					that.$nextTick(function() {
						that.syncCustomerIndex()
						that.restoringDraft = !1
						that.persistDraft(!0)
						if (typeof onDone === 'function') onDone()
					})
				}
				if (draftCartIds.length === 0) {
					that.cartList = []
					finishDraftRestore()
				} else {
					that.syncTransientCart(finishDraftRestore, draftCartIds)
				}
			},
			clearQuotationAfterSubmit(draftKey) {
				let that = this
				const category = that.quotationForm.category
				that.skipDraftPersist = !0
				that.restoringDraft = !0
				if (that.persistDraftTimer) {
					clearTimeout(that.persistDraftTimer)
					that.persistDraftTimer = null
				}
				clearQuotationDraft(category)
				that.cartList = []
				that.extraFeeLines = []
				that.quotationForm.total = 0
				that.quotationForm.total_primary = 0
				that.quotationForm.totalAll = 0
				that.quotationForm.concession = 0
				that.quotationForm.preferential = 0
				that.quotationForm.goods = []
				if (!draftKey) return Promise.resolve()
				return that.$fetch('addons/hlm/api.Cart/clearTransientByOrder', {
					order_number: draftKey
				}).catch(function(error) {
					console.log(error)
				})
			},
			clearDraftAndRestart(draft) {
				let that = this
				const category = that.quotationForm.category
				const prevDraftKey = (draft && draft.quotationForm && (draft.quotationForm.draft_key || draft.quotationForm.order_number))
					|| that.quotationForm.draft_key
					|| that.quotationForm.order_number
				clearQuotationDraft(category)
				const reset = function() {
					that.loading = !0
					that.quotationForm = {
						category: category,
						order_number: '',
						draft_key: '',
						customer_id: '',
						receiving_address: '',
						createTime: '',
						contacts: '',
						contacts_phone: '',
						delivery: '',
						invoice: '',
						total: 0,
						total_primary: 0,
						totalAll: 0,
						concession: 0,
						preferential: 0,
						remarks: '',
						goods: []
					}
					that.typeIndex = 0
					that.customerIndex = ''
					that.cartList = []
					that.extraFeeLines = []
					that.customerInfoCollapsed = !1
					that.startFreshQuotation()
					that.applyQuotationDefaults()
					that.$message({
						message: '已清除暂存内容',
						type: 'success',
						duration: 1500,
						center: !0
					})
				}
				if (prevDraftKey) {
					that.$fetch('addons/hlm/api.Cart/clearTransientByOrder', {
						order_number: prevDraftKey
					}).finally(reset)
				} else {
					reset()
				}
			},
			syncTransientCart(callback, allowedIds) {
				let that = this
				const draftKey = that.quotationForm.draft_key || that.quotationForm.order_number
				if (!draftKey) {
					that.cartList = []
					if (callback) callback()
					return
				}
				if (Array.isArray(allowedIds) && allowedIds.length === 0) {
					that.cartList = []
					if (callback) callback()
					return
				}
				const params = {
					order_number: draftKey,
					category: that.quotationForm.category
				}
				if (Array.isArray(allowedIds) && allowedIds.length > 0) {
					params.ids = allowedIds.join(',')
				}
				that.$fetch('addons/hlm/api.Cart/getTransientList', params).then(function(res) {
					if (res.code == 1) {
						that.cartList = Array.isArray(res.data) ? res.data : []
					} else {
						that.cartList = []
					}
					if (callback) callback()
				}).catch(function(error) {
					console.log(error)
					that.cartList = []
					if (callback) callback()
				})
			},
			persistDraft(immediate) {
				let that = this
				if (that.restoringDraft || that.skipDraftPersist || !that.quotationForm.category) return
				if (that.persistDraftTimer) {
					clearTimeout(that.persistDraftTimer)
					that.persistDraftTimer = null
				}
				const save = function() {
					saveQuotationDraft(that.quotationForm.category, {
						quotationForm: Object.assign({}, that.quotationForm),
						cartList: that.cartList,
						extraFeeLines: that.extraFeeLines,
						customerIndex: that.customerIndex,
						customerInfoCollapsed: that.customerInfoCollapsed
					})
				}
				if (immediate) save()
				else that.persistDraftTimer = setTimeout(save, 400)
			},
			syncCustomerIndex() {
				if (this.customerIndex !== '' && this.customer[this.customerIndex] &&
					String(this.customer[this.customerIndex].id) === String(this.quotationForm.customer_id)) {
					return
				}
				if (!this.quotationForm.customer_id) {
					this.customerIndex = ''
					return
				}
				const idx = this.customer.findIndex(item => String(item.id) === String(this.quotationForm.customer_id))
				this.customerIndex = idx >= 0 ? idx : ''
			},
			resolveCategoryId() {
				let that = this,
					queryId = that.$route.query.categoryId
				if (queryId) {
					sessionStorage.setItem(QUOTATION_CATEGORY_KEY, String(queryId))
					return String(queryId)
				}
				return sessionStorage.getItem(QUOTATION_CATEGORY_KEY)
			},
			initCategory() {
				let that = this,
					categoryId = that.resolveCategoryId()
				if (!categoryId) {
					that.loading = !1
					that.$message({
						message: '请先在产品列表选择产品分类',
						center: !0,
						type: 'warning',
						duration: 1500
					})
					that.$router.replace('/typeList')
					return !1
				}
				that.quotationForm.category = categoryId
				return !0
			},
			refresh(e) {
				let that = this
				const prevDraftKey = that.quotationForm.draft_key || that.quotationForm.order_number
				const category = that.quotationForm.category
				clearQuotationDraft(category)
				const reset = function() {
					that.loading = !0, that.quotationForm = {
							category: category,
							order_number: '',
							draft_key: '',
							customer_id: '',
							receiving_address: '',
							createTime: '',
							contacts: '',
							contacts_phone: '',
							delivery: '',
							invoice: '',
							total: 0,
							total_primary: 0,
							totalAll: 0,
							concession: 0,
							preferential: 0,
							remarks: '',
							goods: []
						}, that.typeIndex = 0, that.customerIndex = '', that.cartList = [],
						that.extraFeeLines = [],
						that.customerInfoCollapsed = !1,
						that.reload()
				}
				if (prevDraftKey) {
					that.$fetch('addons/hlm/api.Cart/clearTransientByOrder', {
						order_number: prevDraftKey
					}).finally(reset)
				} else {
					reset()
				}
			},
			// 获取购物车列表
			getCart(e) {
				let that = this
				that.$fetch('addons/hlm/api.Cart/getCartList',{order_number: that.quotationForm.order_number}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartList = res.data, that.loading = !1,that.getTotal();
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getDelivery(e) {
				let that = this
				that.$fetch('addons/hlm/api.Order/transportList').then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.delivery = res.data
						that.applyQuotationDefaults()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getInvoice(e) {
				let that = this
				that.$fetch('addons/hlm/api.Order/invoiceList').then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.invoice = res.data
						that.applyQuotationDefaults()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			/** 空值时填入本地默认的货物运输 / 发票类型 */
			applyQuotationDefaults() {
				const defaults = loadQuotationDefaults()
				this.quotationDefaults = defaults
				let changed = false
				if ((this.quotationForm.delivery === '' || this.quotationForm.delivery == null)
					&& optionListHasId(this.delivery, defaults.delivery)) {
					this.quotationForm.delivery = resolveOptionId(this.delivery, defaults.delivery)
					changed = true
				}
				if ((this.quotationForm.invoice === '' || this.quotationForm.invoice == null)
					&& optionListHasId(this.invoice, defaults.invoice)) {
					this.quotationForm.invoice = resolveOptionId(this.invoice, defaults.invoice)
					changed = true
				}
				if (changed) this.persistDraft()
			},
			onTransportInvoiceSelectChange() {
				this.persistDraft(true)
			},
			isDefaultOption(field, id) {
				const def = this.quotationDefaults && this.quotationDefaults[field]
				return def !== '' && def != null && String(def) === String(id)
			},
			pinFieldDefault(field, id) {
				if (id === '' || id === null || id === undefined) return
				const clearing = this.isDefaultOption(field, id)
				if (clearing) {
					this.quotationDefaults = saveQuotationDefaultField(field, '')
					this.$message({
						message: '已取消默认',
						type: 'success',
						duration: 1500,
						center: !0,
					})
					return
				}
				this.quotationDefaults = saveQuotationDefaultField(field, id)
				if (field === 'delivery') {
					this.quotationForm.delivery = resolveOptionId(this.delivery, id) || id
				} else if (field === 'invoice') {
					this.quotationForm.invoice = resolveOptionId(this.invoice, id) || id
				}
				this.persistDraft()
				this.$message({
					message: '已设为默认，下次自动填入',
					type: 'success',
					duration: 1500,
					center: !0,
				})
			},
			loadExtraItemOptions() {
				let that = this
				that.$fetch('addons/hlm/api.ExtraItem/options').then(function(res) {
					if (res.code == 1) {
						that.extraItemOptions = Array.isArray(res.data) ? res.data : []
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getNumber(e) {
				let that = this
				that.$fetch('addons/hlm/api.Order/getOrderNumber', {
					type: that.quotationForm.category
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						const prefix = res.data
						that.quotationForm.order_number = prefix
						if (!that.quotationForm.draft_key) {
							const uid = that.userInfo && that.userInfo.id ? that.userInfo.id : '0'
							that.quotationForm.draft_key = createQuotationDraftKey(prefix, uid)
						}
						that.applyQuotationDefaults()
						that.loading = !1
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getCustomer(e) {
				let that = this
				that.$fetch('addons/hlm/api.Customer/getCustomerList', {
					page: that.page,
					limit: that.limit,
					search: ''
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.customer = res.data.list
						that.syncCustomerIndex()
						if (that.quotationForm.customer_id) {
							that.loadCustomerPricing(that.quotationForm.customer_id)
						}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getType(e) {
				let that = this,
					types = [{
						id: '',
						name: '全部分类'
					}]
				that.$fetch('addons/hlm/api.Goods/getCategory', {
					pid: that.quotationForm.category
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.types = types.concat(res.data)
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getGood(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getGoodsList', {
					page: that.page,
					limit: that.limit,
					pid: that.quotationForm.category,
					search: that.search,
					category_id: that.types[that.typeIndex].id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.goodList = res.data.list;
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			changeCustomer(e) {
				// 保留方法名兼容；正式编辑走 onDraftCustomerChange，仅在确定后写回 quotationForm
				let that = this
				if (e === '' || e === null || e === undefined) {
					that.quotationForm.customer_id = ''
					return
				}
				const item = that.customer[e] || that.customer.find((row) => String(row.id) === String(e))
				if (!item) return
				that.quotationForm.customer_id = item.id
				that.quotationForm.contacts = item.contacts
				that.quotationForm.contacts_phone = item.phone
				that.quotationForm.receiving_address = item.receiving_address
			},
			// 删除商品
			delGood(index) {
				let that = this
				const row = that.cartList[index]
				if (!row) return
				const cartId = row.id
				if (!cartId) {
					that.cartList.splice(index, 1)
					that.getTotal()
					return
				}
				that.$fetch('addons/hlm/api.Cart/delTransient', {
					cart_id: cartId,
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartList.splice(index, 1)
						that.getTotal()
					} else {
						that.$message({
							message: res.msg || '删除失败',
							type: 'warning',
							duration: 1500,
							center: !0
						})
					}
				}).catch(function(error) {
					console.log(error)
					that.$message({
						message: '删除失败',
						type: 'error',
						duration: 1500,
						center: !0
					})
				})
			},
			tableRowClassName ({row, rowIndex}) {
			    row.index = rowIndex;
				return this.productRowClassName(row)
			},
			productRowClassName(row) {
				if (isExtraTableRow(row)) return 'quotation-row--extra'
				const cls = []
				if (this.isClonePendingRow(row)) cls.push('quotation-row--pending')
				if (this.isProductRowEditing(row)) cls.push('quotation-row--editing')
				return cls.join(' ')
			},
			isClonePendingRow(row) {
				if (!row || !row.pending_edit) return false
				return this.isCartSizeInvalid(row) || this.isCartNumInvalid(row)
			},
			isProductRowEditing(row) {
				if (!this.cartStatus || !row) return false
				const cartId = this.cartForm && this.cartForm.cart_id
				if (!cartId) return false
				return String(row.id) === String(cartId)
			},
			mobileSheetRowClass(row) {
				return {
					'is-extra': isExtraTableRow(row),
					'is-pending': this.isClonePendingRow(row),
					'is-editing': this.isProductRowEditing(row),
				}
			},
			// 编辑商品
			editCart(e){
				let that = this;
				that.resumeGoodPicker = !1
				const cartIndex = e && e._cartIndex != null ? e._cartIndex : (typeof e === 'number' ? e : e.index);
				const row = that.cartList[cartIndex];
				if (!row) return;
				that.goodActive = cartIndex;
				that.$fetch('addons/hlm/api.Cart/transientDetails', {
					cart_id: row.id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartForm = {
							cart_id: "",
							goods_id: "",
							sku_ids: "",
							goods_long: "",
							goods_wide: "",
							goods_high: "",
							goods_thick: "",
							reference_image: "",
							remarks: "",
							goods_num: 1,
							goods_category: "",
							order_number: "",
							goods_size: "",
							parameter_ids: ""
						};
						that.good = res.data,that.skuActive = -1,that.cartStatus = !0;
						for(let key in that.cartForm){
							that.cartForm[key] = that.good.cart_info[key];
						}
						that.cartForm.cart_id = that.good.cart_info.id;
						if (that.cartList[that.goodActive] && that.cartList[that.goodActive].pending_edit) {
							that.normalizePendingCartForm()
						}
						that.good.valuation_tips = that.good.cart_info.valuation_tips;
						that.good.valuation = that.good.cart_info.goods_valuation;
						that.good.singleton = that.good.cart_info.singleton,that.good.goods_areas = that.good.cart_info.goods_areas;
						that.good.discount_price = that.good.cart_info.discount_price != null && that.good.cart_info.discount_price !== ''
							? that.good.cart_info.discount_price
							: that.good.cart_info.singleton;
						that.good.is_sku = that.good.cart_info.sku_ids!==""?1:0;
						that.good.parameterList = normalizeParameterList(
							that.good.parameterList,
							that.good.cart_info.parameter_ids,
						);
						if(that.good.is_sku==1) {
							that.good.skuPrice.forEach((price,indexP)=>{
								price.skuIds = price.goods_sku_ids.split(",");
								if(price.goods_sku_ids==that.good.cart_info.sku_ids) that.good.cart_info.skuIds = price.goods_sku_ids.split(",");
							});
							that.good.skuList.forEach((item,index)=>{
								item.children.forEach((child,idx)=>{
									if(child.id==that.good.cart_info.skuIds[index]) item.activeId = child.id,item.activeIndex = idx;
								});
							});
							that.setStock();
							if (that.autoSelectSingleSku()) that.setStock();
						}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			/** 行展示金额数值（与表格「金额」列一致） */
			lineAmountDisplay(row) {
				if (!row || this.isCartNumPending(row)) return 0
				const exclusive = this.isExclusivePriceRow(row)
				const unit = Number(exclusive ? this.resolveDiscountPrice(row) : row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num) || !(num > 0)) return 0
				return Number(accMul(unit, num).toFixed(2))
			},
			/** 行成交金额：专属价行用专属价（不参与折扣让利）；其余按折扣价 × 数量 */
			lineAmountByDeal(row) {
				if (!row || this.isCartNumPending(row)) return 0
				if (this.isExclusivePriceRow(row)) return this.lineAmountDisplay(row)
				const unit = Number(this.resolveDiscountPrice(row))
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num) || !(num > 0)) return 0
				return Number(accMul(unit, num).toFixed(2))
			},
			// 小计=产品金额列合计+附加费（单价×数量）；折扣让利=产品成交合计−产品小计；合计=小计+折扣让利
			getTotal() {
				let that = this
				let subtotal = 0
				let dealSum = 0
				;(that.cartList || []).forEach(function(item) {
					subtotal = accAdd(subtotal, that.lineAmountDisplay(item))
					dealSum = accAdd(dealSum, that.lineAmountByDeal(item))
				})
				const concession = accSub(dealSum, subtotal)
				const extraSum = Number(sumExtraFeeLines(that.extraFeeLines))
				that.quotationForm.totalAll = Number(accAdd(subtotal, extraSum)).toFixed(2)
				that.quotationForm.total_primary = Number(subtotal).toFixed(2)
				that.quotationForm.concession = Number(concession).toFixed(2)
				that.quotationForm.preferential = 0
				that.quotationForm.total = Number(accAdd(accAdd(subtotal, concession), extraSum)).toFixed(2)
				that.cartStatsTick += 1
			},
			// footer 小计/合计展示固定两位小数（不改计算过程中的数值）
			formatFooterAmount(field) {
				const v = this.quotationForm[field]
				if (v === '' || v === null || v === undefined) return
				const n = Number(v)
				if (!isFinite(n)) return
				this.quotationForm[field] = n.toFixed(2)
			},
			// 添加产品
			showGood(e) {
				let that = this
				if (!that.quotationForm.customer_id) {
					that.$message({
						message: '请先选择客户，折扣率/专属价才会生效',
						type: 'warning',
						duration: 2000,
						center: !0
					})
				}
				that.getGood(), that.goodStatus = !0, that.good = null
			},
			searchGood(e) {
				let that = this
				that.goodList = [],that.getGood()
			},
			changeType(e) {
				let that = this
				that.typeIndex = e,that.goodList = [], that.getGood()
			},
			selectGood(e) {
				let that = this
				that.good = e
			},
			onGoodRowClick(row) {
				if (!row || !row.id) return
				if (this.isMobile) this.chooseGood(row)
			},
			chooseGood(e) {
				let that = this
				if (!e || !e.id) return
				if (that._choosingGoodId === e.id) return
				that._choosingGoodId = e.id
				that.$fetch('addons/hlm/api.Goods/getGoodsDetails', {
					goods_id: e.id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartForm = {
							cart_id: "",
							goods_id: "",
							sku_ids: "",
							goods_long: "",
							goods_wide: "",
							goods_high: "",
							goods_thick: "",
							reference_image: "",
							remarks: "",
							goods_num: 1,
							goods_category: "",
							order_number: "",
							goods_size: "",
							parameter_ids: ""
						};
						that.good = res.data,that.skuActive = -1;
						that.cartForm.goods_id = that.good.id,that.cartForm.goods_category = that.quotationForm.category,that.cartForm.order_number = that.quotationForm.draft_key || that.quotationForm.order_number;
						that.good.parameterList = normalizeParameterList(that.good.parameterList, null);
						if(that.good.is_sku==1) {
							that.initSkuSelection();
						}
						that.openCartFromPicker();
					}
				}).catch(function(error) {
					console.log(error)
				}).then(function() {
					that._choosingGoodId = null
				})
			},
			addGood(e) {
				let that = this
				if (that.good) {
					that.$fetch('addons/hlm/api.Goods/getGoodsDetails', {
						goods_id: that.good.id
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.cartForm = {
								cart_id: "",
								goods_id: "",
								sku_ids: "",
								goods_long: "",
								goods_wide: "",
								goods_high: "",
								goods_thick: "",
								reference_image: "",
								remarks: "",
								goods_num: 1,
								goods_category: "",
								order_number: "",
								goods_size: "",
								parameter_ids: ""
							};
							that.good = res.data,that.skuActive = -1;
							that.cartForm.goods_id = that.good.id,that.cartForm.goods_category = that.quotationForm.category,that.cartForm.order_number = that.quotationForm.draft_key || that.quotationForm.order_number;
							that.good.parameterList = normalizeParameterList(that.good.parameterList, null);
							if(that.good.is_sku==1) {
								that.initSkuSelection();
							}
							that.openCartFromPicker();
						}
					}).catch(function(error) {
						console.log(error)
					})
				} else {
					that.$message({
						message: '请选择需要添加的产品',
						center: !0,
						type: 'warning',
						duration: 1500
					})
				}
			},
			/** 初始化规格选择：仅 1 项可选时默认选中 */
			initSkuSelection() {
				this.good.skuList.forEach((item) => {
					item.activeId = '';
					item.activeIndex = -1;
				});
				this.good.skuPrice.forEach((price) => {
					price.skuIds = String(price.goods_sku_ids || '').split(',');
				});
				this.setStock();
				if (this.autoSelectSingleSku()) this.setStock();
			},
			/** 规格维度仅 1 项可选时默认选中（未选中的维度） */
			autoSelectSingleSku() {
				const list = this.good && this.good.skuList;
				if (!list || !list.length) return false;
				let changed = false;
				list.forEach((item) => {
					if (item.activeId) return;
					const children = item.children || [];
					const selectable = [];
					children.forEach((child, idx) => {
						if (!child.noStock) selectable.push({ child, idx });
					});
					if (children.length === 1) {
						item.activeIndex = 0;
						item.activeId = children[0].id;
						changed = true;
					} else if (selectable.length === 1) {
						item.activeIndex = selectable[0].idx;
						item.activeId = selectable[0].child.id;
						changed = true;
					}
				});
				return changed;
			},
			isNestedParam,
			leafOptionsForMid,
			selectMidParam(index) {
				const item = onMidParameterChange(this.good.parameterList[index], this.good.parameterList[index].activeMidId);
				this.$set(this.good.parameterList, index, { ...item });
				this.priceInit();
				this.autoCalPrice();
			},
			// 选择参数
			selectParam(val,index){
				let that = this;
				const param = that.good.parameterList[index];
				if (isNestedParam(param)) {
					onLeafParameterChange(param, val);
				} else {
					flatLeafParameterChange(param, val);
				}
				that.$set(that.good.parameterList, index, { ...param });
				that.priceInit();
				that.autoCalPrice();
			},
			// 选择规格
			selectSpec(idx,index){
				let that = this;
				if(that.good.skuList[index].children[idx].noStock) return;
				that.good.skuList = that.good.skuList.map((sku,indexS)=>{
					if(indexS===index) {
						if(sku.activeIndex === idx) {
							sku.activeIndex = -1,sku.activeId = "";
						}else{
							sku.activeIndex = idx,sku.activeId = sku.children[idx].id;
						}
					}
					return sku;
				});
				that.priceInit(),that.setStock();
				// 自动测算
				that.autoCalPrice();
			},
			// 设置规格状态
			setStock(){
				let that = this,isActive = !0;
				that.specIds = [];
				that.good.skuList.forEach((item,index)=>{
					that.specIds.push(item.activeId);
				});
				let specIds = that.specIds.join(",");
				that.good.skuPrice.forEach((price,indexP)=>{
					if(specIds===price.goods_sku_ids) that.skuActive = indexP,isActive = !1;
				});
				if(isActive) that.skuActive = -1;
				syncSwitchParameterVisibility(that, that.good, that.skuActive);
				that.good.skuList.forEach((item,index)=>{
					item.children.forEach((child,idx)=>{
						let ids = that.specIds.map((specId)=>{
							return specId
						}),num = 0;
						ids[index] = child.id;
						that.good.skuPrice.forEach((price,indexP)=>{
							let skuIds = ids.map((spec,indexS)=>{
								if(spec==="") spec = price.skuIds[indexS];
								return spec;
							});
							let skuIdText = skuIds.join(",");
							if(skuIdText===price.goods_sku_ids&&price.status=="up") num++;
						});
						if(num===0) {
							child.noStock = 1;
						}else{
							child.noStock = 0;
						}
					});
				});
			},
			priceInit(){
				let that = this;
				that.$set(that.good,"goods_areas",""),that.$set(that.good,"singleton",""),that.$set(that.good,"discount_price","");
			},
			shouldShowParameterItem(item) {
				return isParameterItemVisible(item, this.good, this.skuActive)
			},
			/** 报价算价/加购时带上客户 id，后端按专属价优先、否则乘折扣率 */
			attachCustomerId(params){
				const id = this.quotationForm && this.quotationForm.customer_id
				if (id) params.customer_id = id
				else params.customer_id = ''
				return params
			},
			/** 选中客户后拉取权威折扣率与专属价；加购算价仍走后端 customer_id */
			loadCustomerPricing(customerId) {
				const that = this
				const id = Number(customerId || 0)
				that.customerDiscountRate = 1
				that.customerExclusivePriceMap = {}
				that.customerExclusiveSkuKeyMap = {}
				if (!id) return
				const cust = (that.customer || []).find(function(row) {
					return String(row.id) === String(id)
				})
				if (cust && cust.discount_rate != null && cust.discount_rate !== '') {
					const rate = Number(cust.discount_rate)
					that.customerDiscountRate = Number.isFinite(rate) && rate > 0 ? rate : 1
				}
				// 详情接口为准，避免列表分页/缓存导致折扣率仍为 1
				that.$fetch('addons/hlm/api.Customer/getCustomerDetails', { id: id }).then(function(detailRes) {
					if (detailRes.code == 1 && detailRes.data) {
						const rate = Number(detailRes.data.discount_rate)
						if (Number.isFinite(rate) && rate > 0) that.customerDiscountRate = rate
						const idx = (that.customer || []).findIndex(function(row) {
							return String(row.id) === String(id)
						})
						if (idx >= 0) that.$set(that.customer[idx], 'discount_rate', String(that.customerDiscountRate))
					}
				}).catch(function(err) {
					console.log(err)
				})
				that.$fetch('addons/hlm/api.Customer/getGoodsPriceList', {
					customer_id: id
				}).then(function(res) {
					if (res.code != 1) return
					const map = {}
					const skuKeyMap = {}
					;(res.data || []).forEach(function(row) {
						const price = Number(row.price)
						const key = String(row.goods_id) + '_' + String(row.sku_id || 0)
						map[key] = price
						const skuKey = String(row.goods_id) + '__' + String(row.goods_sku_ids || '')
						skuKeyMap[skuKey] = price
					})
					that.customerExclusivePriceMap = map
					that.customerExclusiveSkuKeyMap = skuKeyMap
					that.getTotal()
				}).catch(function(err) {
					console.log(err)
				})
			},
			/** 是否客户专属价商品行（不参与折扣让利） */
			isExclusivePriceRow(row) {
				if (!row || !row.goods_id) return false
				const skuKey = String(row.goods_id) + '__' + String(row.sku_ids || '')
				if (this.customerExclusiveSkuKeyMap && this.customerExclusiveSkuKeyMap[skuKey] != null) {
					return true
				}
				const skuField = String(row.sku_ids || '').trim()
				if (!skuField) {
					return this.customerExclusivePriceMap && this.customerExclusivePriceMap[String(row.goods_id) + '_0'] != null
				}
				return false
			},
			/** 折扣价数值：优先 discount_price；旧数据无字段时回退 singleton */
			resolveDiscountPrice(row) {
				if (!row) return ''
				if (row.discount_price !== undefined && row.discount_price !== null && row.discount_price !== '') {
					return row.discount_price
				}
				return row.singleton
			},
			/** 比较折扣价与原价（兼容字符串/数字） */
			isSamePrice(a, b) {
				const na = Number(a)
				const nb = Number(b)
				if (Number.isFinite(na) && Number.isFinite(nb)) {
					return Math.abs(na - nb) < 1e-6
				}
				const emptyA = a === undefined || a === null || a === ''
				const emptyB = b === undefined || b === null || b === ''
				if (emptyA && emptyB) return true
				return String(a) === String(b)
			},
			isDiscountSameAsSingleton(row) {
				if (!row) return true
				return this.isSamePrice(this.resolveDiscountPrice(row), row.singleton)
			},
			/** 折扣价列展示：与单价相同则「-」，否则格式化金额 */
			formatDiscountPriceCell(row) {
				if (this.isDiscountSameAsSingleton(row)) return '-'
				return this.formatMoney(this.resolveDiscountPrice(row))
			},
			/** 金额列：普通行=单价×数量；专属价行=专属价×数量（紫色） */
			formatAmountCell(row) {
				if (!row || this.isCartNumPending(row)) return '-'
				const exclusive = this.isExclusivePriceRow(row)
				const unit = Number(exclusive ? this.resolveDiscountPrice(row) : row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num)) {
					return this.formatMoney(exclusive ? this.resolveDiscountPrice(row) : row.singleton)
				}
				return this.formatMoney(accMul(unit, num))
			},
			formatAmountBySingleton(row) {
				return this.formatAmountCell(row)
			},
			// 自动测算 - 检查条件后自动调用测算
			autoCalPrice(){
				let that = this;
				// 如果没有产品信息，不进行测算
				if(!that.good) return;
				
				// 检查规格是否选择完整（如果有规格）
				if(that.good.is_sku==1){
					let specNum = 0;
					that.good.skuList.forEach((item,index)=>{
						if(item.activeId!==""){
							specNum++;
						}
					});
					// 如果规格未选择完整，不进行测算
					if(specNum!==that.good.skuList.length){
						return;
					}
				}
				
				// 检查必填的尺寸参数
				let needLong = that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13;
				let needHigh = that.good.valuation==6||that.good.valuation==7||that.good.valuation==9;
				let needWide = that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13;
				let needThick = that.good.valuation==9;
				
				// 检查必填尺寸是否都已填写
				if(needLong && (!that.cartForm.goods_long || that.cartForm.goods_long==="")) return;
				if(needHigh && (!that.cartForm.goods_high || that.cartForm.goods_high==="")) return;
				if(needWide && (!that.cartForm.goods_wide || that.cartForm.goods_wide==="")) return;
				if(needThick && (!that.cartForm.goods_thick || that.cartForm.goods_thick==="")) return;
				
				// 如果不需要尺寸参数，或者所有必填尺寸都已填写，则自动测算
				that.calPrice();
			},
			// 测算
			calPrice(showMessage){
				let that = this
				let params = that.cartForm,specNum = 0,paramNum = 0;
				if(that.good.is_sku==1){
					that.good.skuList.forEach((item,index)=>{
						if(item.activeId!==""){
							specNum++;
						}
					});
				}
				if(that.good.is_sku==1&&specNum!==that.good.skuList.length){
					that.$message({
						message: `请选择${that.good.skuList[specNum].name}`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if(that.good.is_sku==1) {
					let sku_ids = that.good.skuList.map((item,index)=>{
						return item.activeId;
					});
					let sku_idText = sku_ids.join(",");
					that.good.skuPrice.forEach((item,index)=>{
						if(item.goods_sku_ids===sku_idText) params.sku_ids = item.id;
					});
				};
				let parameter_ids = collectParameterIds(that.good.parameterList, that.good, that.skuActive);
				params.parameter_ids = parameter_ids;
				if((that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_long===""){
					that.$message({
						message: `请输入产品长度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if((that.good.valuation==6||that.good.valuation==7||that.good.valuation==9)&&that.cartForm.goods_high===""){
					that.$message({
						message: `请输入产品高度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if((that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_wide===""){
					that.$message({
						message: `请输入产品宽度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if(that.good.valuation==9&&that.cartForm.goods_thick===""){
					that.$message({
						message: `请输入产品厚度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				that.$post('addons/hlm/api.Cart/getPirec', that.attachCustomerId(params)).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.$set(that.good,"goods_areas",res.data.goods_areas),that.$set(that.good,"singleton",res.data.singleton),that.$set(that.good,"discount_price",res.data.discount_price != null ? res.data.discount_price : res.data.singleton),that.$forceUpdate();
						// 只有在手动点击测算按钮时才显示成功提示，自动测算时不显示
						if(showMessage){
							that.$message({
								message: '测算成功',
								type: 'success',
								duration: 1500,
								center: !0,
								onClose() {
									
								}
							});
						}
					} else {
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 添加or修改商品
			submitCart(cartForm) {
				let that = this
				if(that.cartSubmit) return;
				const formRef = that.cartFormRef() || that.$refs[cartForm]
				if (!formRef) return
				formRef.validate((valid) => {
					if (valid) {
						if (that.isCartFormPendingInvalid()) {
							that.$message({
								message: '请填写有效的尺寸与数量后再确认添加',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						let params = that.cartForm,sku_ids = [];
						if(that.good.is_sku==1){
							that.good.skuList.forEach((item,index)=>{
								if(item.activeId!==""){
									sku_ids.push(item.activeId);
								}else{
									that.$message({
										message: `请选择${item.name}`,
										type: 'warning',
										duration: 1500,
										center: !0
									});
									throw new Error("emptySku");
								}
							});
							if(sku_ids.length<that.good.skuList.length) return;
							let sku_idText = sku_ids.join(",");
							that.good.skuPrice.forEach((item,index)=>{
								if(item.goods_sku_ids===sku_idText) params.sku_ids = item.id;
							});
						}
						params.parameter_ids = collectParameterIds(that.good.parameterList, that.good, that.skuActive);
						if((that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13)&&that.isEmptyDimValue(that.cartForm.goods_long)){
							that.$message({
								message: `请输入产品长度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if((that.good.valuation==6||that.good.valuation==7||that.good.valuation==9)&&that.isEmptyDimValue(that.cartForm.goods_high)){
							that.$message({
								message: `请输入产品高度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if((that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13)&&that.isEmptyDimValue(that.cartForm.goods_wide)){
							that.$message({
								message: `请输入产品宽度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if(that.good.valuation==9&&that.isEmptyDimValue(that.cartForm.goods_thick)){
							that.$message({
								message: `请输入产品厚度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if (that.isCartNumInvalid(that.cartForm)) {
							that.$message({
								message: '请输入数量',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						that.cartSubmit = !0;
						that.$post('addons/hlm/api.Cart/changeTransient', that.attachCustomerId(params)).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								const saved = res.data
								saved.pending_edit = that.isCartFormPendingInvalid()
								if (that.cartForm.cart_id === '') {
									that.cartList.push(saved)
								} else {
									// Vue2：按索引赋值不会触发依赖，需 $set 才能刷新表格与统计
									that.$set(that.cartList, that.goodActive, saved)
								}
								that.cartStatus = !1,that.goodStatus = !1,that.good = null,that.specIds = [],that.getTotal(),that.cartSubmit = !1;
								that.$message({
									message: that.cartForm.cart_id===""?'添加成功':"修改成功",
									type: 'success',
									duration: 1000,
									center: !0,
									onClose() {
										
									}
								});
							} else {
								that.cartSubmit = !1;
							}
						}).catch(function(error) {
							console.log(error)
							that.cartSubmit = !1;
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			submitForm(quotationForm) {
				let that = this
				if (that.quotationStatus) return
				that.validateCustomerInfo(function(customerValid) {
					if (!customerValid) {
						that.$message({
							message: '请完善客户信息',
							type: 'warning',
							duration: 1500,
							center: !0
						})
						that.openCustomerInfoDialog()
						return
					}
					that.$refs[quotationForm].validate((valid) => {
					if (!valid) {
						that.$message({
							message: '请选择货物运输和发票类型',
							type: 'warning',
							duration: 1500,
							center: !0
						})
						return
					}
					let params = that.quotationForm
						if (!(Number(params.total) > 0)) {
							that.$message({
								message: '请添加产品',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						if (that.hasPendingCloneItems()) {
							that.$message({
								message: '存在未编辑的克隆产品（尺寸或数量为「-」），请先编辑核对后再确认单据',
								type: 'warning',
								duration: 2500,
								center: !0
							})
							return
						}
						that.quotationStatus = !0
						params.offertime = getTimestamp(params.createTime)
						const draftKey = that.quotationForm.draft_key || that.quotationForm.order_number
						const categoryId = Number(that.quotationForm.category) || 0
						const seenIds = {}
						const validCart = that.cartList.filter(function(item) {
							if (!item || !item.id) return false
							if (seenIds[item.id]) return false
							if (String(item.order_number || '') !== String(draftKey)) return false
							if (categoryId && Number(item.goods_category) !== categoryId) return false
							seenIds[item.id] = !0
							return true
						})
						if (validCart.length === 0) {
							that.$message({
								message: '请添加产品',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							that.quotationStatus = !1
							return
						}
						if (validCart.length !== that.cartList.length) {
							that.cartList = validCart
							that.getTotal()
							that.$message({
								message: '已移除无效或重复的商品，请核对后再提交',
								type: 'warning',
								duration: 2500,
								center: !0
							})
							that.quotationStatus = !1
							return
						}
						let transient_ids = validCart.map(function(item) {
							return item.id
						})
						params.transient_ids = transient_ids.join(",")
						params.draft_key = draftKey
						params.order_number = that.quotationForm.order_number
						params.extra_fees = serializeExtraFees(that.extraFeeLines)
						that.$post('addons/hlm/api.Order/add', params).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								const orderId = res.data && (res.data.id || res.data.order_id)
								that.clearQuotationAfterSubmit(draftKey).finally(function() {
									that.$message({
										message: '添加成功',
										type: 'success',
										duration: 1500,
										center: !0,
										onClose() {
											that.quotationStatus = !1
											if (orderId) {
												that.$router.push(`/offerDetail?id=${orderId}`)
											} else {
												that.refresh()
											}
										}
									})
								})
							} else {
								that.quotationStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.quotationStatus = !1
						})
				});
				});
			},
			// 克隆商品（复制当前行并插入其后）
			cloneCart(index) {
				let that = this
				const row = that.cartList[index]
				if (!row || !row.id) return
				that.$fetch('addons/hlm/api.Cart/transientDetails', {
					cart_id: row.id
				}).then(function(res) {
					if (res.code != 1) return
					const info = res.data.cart_info
					let params = {
						cart_id: '',
						goods_id: info.goods_id,
						sku_ids: '',
						goods_long: '',
						goods_wide: '',
						goods_high: '',
						goods_thick: '',
						reference_image: info.reference_image || '',
						remarks: info.remarks || '',
						goods_num: 0,
						goods_category: that.quotationForm.category,
						order_number: that.quotationForm.draft_key || that.quotationForm.order_number,
						goods_size: '',
						parameter_ids: info.parameter_ids || ''
					}
					if (info.sku_ids && res.data.skuPrice) {
						res.data.skuPrice.forEach(function(item) {
							if (item.goods_sku_ids === info.sku_ids) params.sku_ids = item.id
						})
					}
					that.$post('addons/hlm/api.Cart/changeTransient', that.attachCustomerId(params)).then(function(res2) {
						if (res2.code == 1) {
							const cloned = res2.data
							cloned.pending_edit = !0
							that.cartList.splice(index + 1, 0, cloned)
							that.getTotal()
							that.$message({
								message: '克隆成功，请编辑核对尺寸与数量',
								type: 'warning',
								duration: 2500,
								center: !0
							})
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 上下移动
			upLayer(index, row) {
				var that = this;
				if (index == 0) {
					that.$message({
						message: "处于顶端，不能继续上移",
						center: !0,
						type: "warning"
					});
				} else {
					let upDate = that.cartList[index - 1]
					that.cartList.splice(index - 1, 1)
					that.cartList.splice(index, 0, upDate)
				}
			},
			downLayer(index, row) {
				var that = this;
				if (index + 1 === that.cartList.length) {
					that.$message({
						message: "处于末端端，不能继续下移",
						center: !0,
						type: "warning"
					});
				} else {
					let downDate = that.cartList[index + 1]
					that.cartList.splice(index + 1, 1)
					that.cartList.splice(index, 0, downDate)
				}
			},
			sizeSpan({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 4) {
					// if (columnIndex === 0) {
					// 	return [1, 2];
					// } else if (columnIndex === 1) {
					// 	return [0, 0];
					// }
				}
			},
			printQuotation() {
				let that = this
			},
			printInvoice() {
				let that = this
			}
		}
	};
</script>

<style src='../assets/css/quotation.css'>
	/* px2rem能正常转换 */
</style>
<style src='../assets/css/quotation-mobile.css'></style>
